/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
function e(e, n, t, r, o, i, a) {
  try {
    var c = e[i](a),
      u = c.value;
  } catch (e) {
    return void t(e);
  }
  c.done ? n(u) : Promise.resolve(u).then(r, o);
}
function n(n) {
  return function () {
    var t = this,
      r = arguments;
    return new Promise(function (o, i) {
      var a = n.apply(t, r);
      function c(n) {
        e(a, o, i, c, u, "next", n);
      }
      function u(n) {
        e(a, o, i, c, u, "throw", n);
      }
      c(void 0);
    });
  };
}
var t = {
    apiKey: "",
    apiSecret: "",
    env: "",
    sessionId: "",
    sdkVersionCode: 1,
    sdkVersionName: "1.0.0",
  },
  r = {
    FPJS_PUB_KEY: "8txzxEzzSENaOvZh3VGc",
    PERSISTANCE_KEY: "__pidv1__",
    SIGN3_DOMAIN: "sign3.in",
    INITIALIZATION_VALIDATIONS: {
      PLEASE_PROVIDE_TEXT: "Please provide valid value(s) for",
      API_KEY: "api key",
      API_SECRET: "api secret",
      ENVIRONMENT: "env",
      SESSIONID: "Session Id",
      TO_INITIALIZE_TEXT: "to initialize sign3 solution",
      REGISTER_CATCH_ERROR:
        "Sorry, due to some technical issue not able to register our client",
      DEVICE_IDENTIFICATION_FAILED: "Could not generate device ID",
    },
    COULD_NOT_GATHER_INTELLIGENCE_ERROR:
      "Could not generate intellegence data...",
  };
function o(e) {
  return (
    (o =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              "function" == typeof Symbol &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          }),
    o(e)
  );
}
function i(e, n, t) {
  return (
    (n = (function (e) {
      var n = (function (e) {
        if ("object" != o(e) || !e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var t = n.call(e, "string");
          if ("object" != o(t)) return t;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      })(e);
      return "symbol" == o(n) ? n : n + "";
    })(n)) in e
      ? Object.defineProperty(e, n, {
          value: t,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (e[n] = t),
    e
  );
}
function a(e, n) {
  if (null == e) return {};
  var t,
    r,
    o = (function (e, n) {
      if (null == e) return {};
      var t = {};
      for (var r in e)
        if ({}.hasOwnProperty.call(e, r)) {
          if (-1 !== n.indexOf(r)) continue;
          t[r] = e[r];
        }
      return t;
    })(e, n);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      (t = i[r]),
        -1 === n.indexOf(t) &&
          {}.propertyIsEnumerable.call(e, t) &&
          (o[t] = e[t]);
  }
  return o;
}
var c = ["body", "headers"];
function u(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n &&
      (r = r.filter(function (n) {
        return Object.getOwnPropertyDescriptor(e, n).enumerable;
      })),
      t.push.apply(t, r);
  }
  return t;
}
function l(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2
      ? u(Object(t), !0).forEach(function (n) {
          i(e, n, t[n]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : u(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
  }
  return e;
}
var s = {
  shouldTrack: !0,
  timeOutLimit: 1e4,
  shouldTimeout: !0,
  retrys: 3,
  bodyToString: !0,
};
function d() {
  return (d = n(function* (e, n, t) {
    if (200 === e.status) {
      var r = yield e.json();
      return Promise.resolve({ ex: r, tId: e.headers.get("Sid") });
    }
    return Promise.reject(new Error("Failed to fetch"));
  })).apply(this, arguments);
}
var f = function e(n) {
    var t,
      r,
      o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : s,
      { body: u, headers: f } = o,
      m = a(o, c),
      {
        shouldTrack: v,
        timeOutLimit: p,
        shouldTimeout: h,
        retrys: y,
        bodyToString: g,
      } = i,
      b = new Headers(l({ "Content-Type": "application/json" }, f));
    return (
      h &&
        "undefined" != typeof AbortController &&
        ((t = new AbortController()),
        (r = setTimeout(function () {
          return t && t.abort && t.abort();
        }, p))),
      fetch(
        n,
        l(
          l({ method: "POST", headers: b, body: g ? JSON.stringify(u) : u }, m),
          {},
          { signal: t ? t.signal : void 0 }
        )
      )
        .then(function (e) {
          return (
            r && clearTimeout(r),
            (function (e, n, t) {
              return d.apply(this, arguments);
            })(e, n, v)
          );
        })
        .catch(function (t) {
          return y > 0 &&
            "string" == typeof t.message &&
            t.message.indexOf("abort") > -1
            ? e(n, o, {
                shouldTrack: v,
                timeOutLimit: p,
                shouldTimeout: h,
                retrys: y - 1,
              })
            : Promise.reject(new Error(t));
        })
    );
  },
  m = {
    PROD: {
      INTELLIGENCE_URL:
        "https://intelligence-b.sign3.in/v1/userInsights/web?cstate=true",
    },
    STAGE: {
      INTELLIGENCE_URL:
        "https://intelligence-staging-b.sign3.in/v1/userInsights/web?cstate=true",
    },
  };
function v(e, n) {
  (null == n || n > e.length) && (n = e.length);
  for (var t = 0, r = Array(n); t < n; t++) r[t] = e[t];
  return r;
}
function p(e) {
  return (
    (function (e) {
      if (Array.isArray(e)) return v(e);
    })(e) ||
    (function (e) {
      if (
        ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
        null != e["@@iterator"]
      )
        return Array.from(e);
    })(e) ||
    (function (e, n) {
      if (e) {
        if ("string" == typeof e) return v(e, n);
        var t = {}.toString.call(e).slice(8, -1);
        return (
          "Object" === t && e.constructor && (t = e.constructor.name),
          "Map" === t || "Set" === t
            ? Array.from(e)
            : "Arguments" === t ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
            ? v(e, n)
            : void 0
        );
      }
    })(e) ||
    (function () {
      throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
      );
    })()
  );
}
var h = window.crypto,
  { subtle: y } = h || {},
  g = (function () {
    var e = n(function* (e, n) {
      try {
        var t = new TextEncoder(),
          r = yield y.importKey("raw", t.encode(n), { name: "PBKDF2" }, !1, [
            "deriveKey",
          ]);
        return yield y.deriveKey(
          {
            name: "PBKDF2",
            salt: t.encode(e),
            iterations: 1e3,
            hash: "SHA-256",
          },
          r,
          { name: "AES-CBC", length: 128 },
          !1,
          ["encrypt", "decrypt"]
        );
      } catch (e) {
        return null;
      }
    });
    return function (n, t) {
      return e.apply(this, arguments);
    };
  })(),
  b = (function () {
    var e = n(function* (e, n, t) {
      try {
        var r = yield g(e, n);
        if (!r) return "";
        var o = h.getRandomValues(new Uint8Array(16)),
          i = new TextEncoder(),
          a = yield y.encrypt({ name: "AES-CBC", iv: o }, r, i.encode(t));
        return {
          encodedData: btoa(
            String.fromCharCode.apply(String, p(new Uint8Array(a)))
          ),
          iv: Array.from(o)
            .map(function (e) {
              return e.toString(16).padStart(2, "0");
            })
            .join(""),
        };
      } catch (e) {
        return "";
      }
    });
    return function (n, t, r) {
      return e.apply(this, arguments);
    };
  })();
function w(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n &&
      (r = r.filter(function (n) {
        return Object.getOwnPropertyDescriptor(e, n).enumerable;
      })),
      t.push.apply(t, r);
  }
  return t;
}
function S(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2
      ? w(Object(t), !0).forEach(function (n) {
          i(e, n, t[n]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : w(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
  }
  return e;
}
function E() {
  return (E = n(function* (e, n, r, o) {
    var {
        env: i,
        sessionId: a,
        sdkVersionCode: c,
        sdkVersionName: u,
        apiKey: l,
        apiSecret: d,
      } = t,
      v = { a: null, b: null, c: null };
    n.bm && ((v = n.bm), delete n.bm);
    var p = (function () {
        return ((e = t.env), m[e] || m.STAGE).INTELLIGENCE_URL;
        var e;
      })(),
      h = {
        d: null,
        f: a,
        b: e,
        a: n,
        c: v,
        g: o || null,
        v: "full",
        ze: r || {},
      },
      { encodedData: y, iv: g } = yield b(l, d, JSON.stringify(h)),
      w = "".concat(l, ":").concat(d),
      E = {
        Authorization: "Basic ".concat(window.btoa(w)),
        "TENANT-ID": g,
        "Content-Type": "text/plain",
        "sdk-version-name": u,
        "sdk-version-code": c,
        "client-ts-millis": Date.now(),
      };
    return f(p, { body: y, headers: E }, S(S({}, s), {}, { bodyToString: !1 }));
  })).apply(this, arguments);
}
var P = function (e, n) {
    return matchMedia("(".concat(e, ": ").concat(n, ")")).matches;
  },
  O = function (e) {
    return parseFloat(e);
  };
function j(e) {
  return parseInt(e, 10);
}
var L = function (e, n) {
  return "number" == typeof e && Number.isNaN(e) ? n : e;
};
function R(e) {
  return e.reduce(function (e, n) {
    return e + (n ? 1 : 0);
  }, 0);
}
var C,
  A,
  k = function (e) {
    return (
      null == e ||
      "" === e ||
      ("object" == typeof value && 0 === Object.keys(e).length)
    );
  };
function I(e, n) {
  var t = {},
    r = e.getBoundingClientRect();
  ["x", "y", "left", "right", "bottom", "height", "top", "width"].forEach(
    function (e) {
      e in r && (t[e] = r[e]);
    }
  );
  var o = n.getComputedStyle(e, null).getPropertyValue("font-family");
  return (t.font = o), t;
}
function x(e) {
  return Object.getOwnPropertyNames(e);
}
var T = window,
  N = navigator,
  _ =
    R([
      "MSCSSMatrix" in T,
      "msSetImmediate" in T,
      "msIndexedDB" in T,
      "msMaxTouchPoints" in N,
      "msPointerEnabled" in N,
    ]) >= 4,
  V =
    R([
      "msWriteProfilerMark" in T,
      "MSStream" in T,
      "msLaunchUri" in N,
      "msSaveBlob" in N,
    ]) >= 3 && !_(),
  D =
    R([
      "webkitPersistentStorage" in N,
      "webkitTemporaryStorage" in N,
      0 === N.vendor.indexOf("Google"),
      "webkitResolveLocalFileSystemURL" in T,
      "BatteryManager" in T,
      "webkitMediaStream" in T,
      "webkitSpeechGrammar" in T,
    ]) >= 5,
  M =
    R([
      "ApplePayError" in T,
      "CSSPrimitiveValue" in T,
      "Counter" in T,
      0 === N.vendor.indexOf("Apple"),
      "RGBColor" in T,
      "WebKitMediaKeys" in T,
    ]) >= 4,
  F =
    R([
      "safari" in T,
      !("ongestureend" in T),
      !("TouchEvent" in T),
      !("orientation" in T),
      HTMLElement && !("autocapitalize" in HTMLElement.prototype),
      Document && "pointerLockElement" in Document.prototype,
    ]) >= 4,
  W =
    R([
      "safari" in T,
      !("DeviceMotionEvent" in T),
      !("ongestureend" in T),
      !("standalone" in navigator),
    ]) >= 3,
  H =
    R([
      "maxTouchPoints" in N,
      "mediaCapabilities" in N,
      "PointerEvent" in T,
      "visualViewport" in T,
      "onafterprint" in T,
    ]) >= 4,
  Z =
    R([
      "buildID" in navigator,
      "MozAppearance" in
        (null !==
          (C =
            null === (A = document.documentElement) || void 0 === A
              ? void 0
              : A.style) && void 0 !== C
          ? C
          : {}),
      "onmozfullscreenchange" in T,
      "mozInnerScreenX" in T,
      "CSSMozDocumentRule" in T,
      "CanvasCaptureMediaStream" in T,
    ]) >= 4,
  G =
    R([
      !("PushManager" in window),
      !("AudioBuffer" in window),
      !("RTCPeerConnection" in window),
      !("geolocation" in navigator),
      !("ServiceWorker" in window),
    ]) >= 3;
function B() {
  var e = Audio.prototype,
    { visualViewport: n } = T;
  return (
    R([
      "srLatency" in e,
      "srChannelCount" in e,
      "devicePosture" in N,
      n && "segments" in n,
      "getTextInformation" in Image.prototype,
    ]) >= 3
  );
}
var Y =
    R([
      "ClipboardItem" in window,
      "PerformanceEventTiming" in window,
      "RTCSctpTransport" in window,
    ]) >= 2,
  X = !self.document && self.WorkerGlobalScope;
function z(e, n) {
  return new Promise(function (t) {
    return setTimeout(t, e, n);
  });
}
function J(e, n) {
  for (
    var t = arguments.length, r = new Array(t > 2 ? t - 2 : 0), o = 2;
    o < t;
    o++
  )
    r[o - 2] = arguments[o];
  try {
    var i = e();
    !(function (e) {
      return !!e && "function" == typeof e.then;
    })(i)
      ? n.apply(void 0, [!0, i].concat(r))
      : i.then(
          function (e) {
            return n.apply(void 0, [!0, e].concat(r));
          },
          function (e) {
            return n.apply(void 0, [!1, e].concat(r));
          }
        );
  } catch (e) {
    n.apply(void 0, [!1, e].concat(r));
  }
}
function U() {
  return (U = n(function* (e, n) {
    for (var t = [], r = 0; r < e.length; ++r) {
      for (var o = e[r], i = [], a = 0; a < o.length; ++a) i[a] = n(o[a], a);
      (t[r] = i), yield Q();
    }
    return t;
  })).apply(this, arguments);
}
function K() {
  return (
    (K = n(function* (e, n) {
      for (
        var t =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 16,
          r = Array(e.length),
          o = Date.now(),
          i = 0;
        i < e.length;
        ++i
      ) {
        r[i] = n(e[i], i);
        var a = Date.now();
        a >= o + t && ((o = a), yield Q());
      }
      return r;
    })),
    K.apply(this, arguments)
  );
}
function Q() {
  return new Promise(function (e) {
    var n = new MessageChannel();
    (n.port1.onmessage = function () {
      return e();
    }),
      n.port2.postMessage(null);
  });
}
function q(e) {
  return (
    e.then(void 0, function () {
      return null;
    }),
    e
  );
}
var $ = function (e) {
    var [n, t] = (function (e) {
        for (
          var n = "Unexpected syntax '".concat(e, "'"),
            t = /^\s*([a-z-]*)(.*)$/i.exec(e),
            r = t[1] || void 0,
            o = {},
            i = /([.:#][\w-]+|\[.+?\])/gi,
            a = function (e, n) {
              (o[e] = o[e] || []), o[e].push(n);
            };
          ;

        ) {
          var c = i.exec(t[2]);
          if (!c) break;
          var u = c[0];
          switch (u[0]) {
            case ".":
              a("class", u.slice(1));
              break;
            case "#":
              a("id", u.slice(1));
              break;
            case "[":
              var l,
                s,
                d =
                  /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(
                    u
                  );
              if (!d) throw new Error(n);
              a(
                d[1],
                null !== (l = null !== (s = d[4]) && void 0 !== s ? s : d[5]) &&
                  void 0 !== l
                  ? l
                  : ""
              );
              break;
            default:
              throw new Error(n);
          }
        }
        return [r, o];
      })(e),
      r = document.createElement(null != n ? n : "div");
    return (
      Object.keys(t).forEach(function (e) {
        var n,
          o = t[e].join(" ");
        "style" === e
          ? ((n = r.style),
            o.split(";").forEach(function (e) {
              var t = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(e);
              if (t) {
                var [, r, o, , i] = t;
                n.setProperty(r, o, i || "");
              }
            }))
          : r.setAttribute(e, o);
      }),
      r
    );
  },
  ee = function (e) {
    var n =
        arguments.length > 1 && void 0 !== arguments[1]
          ? arguments[1]
          : "SHA-256",
      t = "".concat(JSON.stringify(e)),
      r = new TextEncoder().encode(t);
    return crypto.subtle.digest(n, r).then(function (e) {
      return Array.from(new Uint8Array(e))
        .map(function (e) {
          return ("00" + e.toString(16)).slice(-2);
        })
        .join("");
    });
  },
  ne = {},
  te =
    "\n\theight: 100vh;\n\twidth: 100vw;\n\tposition: absolute;\n\tleft:-10000px;\n\tvisibility: hidden;\n";
function re() {
  return (
    String.fromCharCode(26 * Math.random() + 97) +
    Math.random().toString(36).slice(-7)
  );
}
var { iframeWindow: oe, div: ie } =
    (function () {
      if (X) return { iframeWindow: self };
      try {
        var e = self.length,
          n = new DocumentFragment(),
          t = document.createElement("div"),
          r = re();
        t.setAttribute("id", r),
          n.appendChild(t),
          (t.innerHTML = '<div style="'.concat(
            te,
            '"><iframe></iframe></div>'
          )),
          document.body.appendChild(n);
        var o = (function (e) {
          try {
            if (!D) return e;
            var n = e.document.createElement("div");
            n.setAttribute("id", re()),
              n.setAttribute("style", te),
              (n.innerHTML = "<div><iframe></iframe></div>"),
              e.document.body.appendChild(n);
            var t = p(p(n.childNodes)[0].childNodes)[0];
            if (!t) return null;
            var { contentWindow: r } = t || {};
            if (!r) return null;
            var o = r.document.createElement("div");
            return (
              (o.innerHTML = "<div><iframe></iframe></div>"),
              r.document.body.appendChild(o),
              p(p(o.childNodes)[0].childNodes)[0].contentWindow
            );
          } catch (n) {
            return e;
          }
        })(self[e]);
        return { iframeWindow: o || self, div: t };
      } catch (e) {
        return { iframeWindow: self };
      }
    })() || {},
  ae =
    String.fromCharCode(26 * Math.random() + 97) +
    Math.random().toString(36).slice(-7);
function ce(e, n) {
  return new Promise(function (t) {
    ue(t, e, n);
  });
}
function ue(e, n) {
  for (
    var t = arguments.length, r = new Array(t > 2 ? t - 2 : 0), o = 2;
    o < t;
    o++
  )
    r[o - 2] = arguments[o];
  var i = document,
    a = "visibilitychange",
    c = function () {
      i.hidden ? l() : u();
    },
    { start: u, stop: l } = (function (e, n, t) {
      for (
        var r = arguments.length, o = new Array(r > 3 ? r - 3 : 0), i = 3;
        i < r;
        i++
      )
        o[i - 3] = arguments[i];
      var a,
        c = !1,
        u = e,
        l = 0,
        s = function () {
          c ||
            a ||
            ((l = Date.now()),
            (a = le(function () {
              (c = !0), t.apply(void 0, o);
            }, u)));
        };
      return (
        n && s(),
        {
          start: s,
          stop: function () {
            !c && a && (clearTimeout(a), (a = void 0), (u -= Date.now() - l));
          },
        }
      );
    })(n, !i.hidden, function () {
      i.removeEventListener(a, c), e.apply(void 0, r);
    });
  return (
    i.addEventListener(a, c),
    function () {
      i.removeEventListener(a, c), l();
    }
  );
}
function le(e, n) {
  for (
    var t = arguments.length, r = new Array(t > 2 ? t - 2 : 0), o = 2;
    o < t;
    o++
  )
    r[o - 2] = arguments[o];
  var i,
    a = Date.now() + n,
    c = function () {
      i = setTimeout(function () {
        Date.now() < a ? c() : e.apply(void 0, r);
      }, a - Date.now());
    };
  return (
    c(),
    function () {
      return clearTimeout(i);
    }
  );
}
var se = null;
function de() {
  if (se) return se;
  var e,
    n = document.createElement("canvas");
  for (var t of (n.addEventListener("webglCreateContextError", function () {
    return (e = void 0);
  }),
  ["webgl", "experimental-webgl"])) {
    try {
      e = n.getContext(t);
    } catch {}
    if (e) break;
  }
  return (se = e);
}
function fe(e) {
  return "function" == typeof e.getParameter;
}
var me = function (e, n) {
  return new Promise(function (t, r) {
    try {
      if (
        ("indexedDB" in window ||
          ((indexedDB =
            window.indexedDB ||
            window.mozIndexedDB ||
            window.webkitIndexedDB ||
            window.msIndexedDB),
          (IDBTransaction =
            window.IDBTransaction ||
            window.webkitIDBTransaction ||
            window.msIDBTransaction),
          (IDBKeyRange =
            window.IDBKeyRange ||
            window.webkitIDBKeyRange ||
            window.msIDBKeyRange)),
        indexedDB)
      ) {
        var o = indexedDB.open("hyd_db", 1);
        (o.onerror = function () {
          t(null);
        }),
          (o.onupgradeneeded = function (e) {
            e.target.result.createObjectStore("hydcookie", {
              keyPath: "key",
              unique: !1,
            });
          }),
          (o.onsuccess =
            null == n
              ? function (n) {
                  var { result: r } = n.target;
                  if (r.objectStoreNames.contains("hydcookie"))
                    try {
                      var o = r
                        .transaction(["hydcookie"])
                        .objectStore("hydcookie")
                        .get(e);
                      o.onsuccess = function () {
                        void 0 === o.result ? t(null) : t(o.result.value);
                      };
                    } catch (e) {
                      t(null);
                    } finally {
                      r.close();
                    }
                  else t(null);
                }
              : function (r) {
                  var o = r.target.result;
                  try {
                    o.objectStoreNames.contains("hydcookie") &&
                      o
                        .transaction(["hydcookie"], "readwrite")
                        .objectStore("hydcookie")
                        .put({ key: e, value: n });
                  } catch (e) {
                    t(null);
                  } finally {
                    o.close(), t(null);
                  }
                });
      }
    } catch (e) {
      t(null);
    }
  });
};
var ve = [
  "availableAttr",
  "PARAMS",
  "SHADR_PRCSN",
  "EXTN",
  "EXTN_PARAM",
  "PRC_EXTN_PARAM",
  "PRC_PRARAMS",
];
function pe(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n &&
      (r = r.filter(function (n) {
        return Object.getOwnPropertyDescriptor(e, n).enumerable;
      })),
      t.push.apply(t, r);
  }
  return t;
}
function he(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2
      ? pe(Object(t), !0).forEach(function (n) {
          i(e, n, t[n]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : pe(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
  }
  return e;
}
var ye = new Set([
    10752, 2849, 2884, 2885, 2886, 2928, 2929, 2930, 2931, 2932, 2960, 2961,
    2962, 2963, 2964, 2965, 2966, 2967, 2968, 2978, 3024, 3042, 3088, 3089,
    3106, 3107, 32773, 32777, 32777, 32823, 32824, 32936, 32937, 32938, 32939,
    32968, 32969, 32970, 32971, 3317, 33170, 3333, 3379, 3386, 33901, 33902,
    34016, 34024, 34076, 3408, 3410, 3411, 3412, 3413, 3414, 3415, 34467, 34816,
    34817, 34818, 34819, 34877, 34921, 34930, 35660, 35661, 35724, 35738, 35739,
    36003, 36004, 36005, 36347, 36348, 36349, 37440, 37441, 37443, 7936, 7937,
    7938,
  ]),
  ge = new Set([
    34047, 35723, 36063, 34852, 34853, 34854, 34229, 36392, 36795, 38449,
  ]),
  be = ["FRAGMENT_SHADER", "VERTEX_SHADER"],
  we = [
    "LOW_FLOAT",
    "MEDIUM_FLOAT",
    "HIGH_FLOAT",
    "LOW_INT",
    "MEDIUM_INT",
    "HIGH_INT",
  ],
  Se = function (e) {
    return Object.keys(e.__proto__).filter(function (e) {
      return "string" == typeof e && !e.match(/[^A-Z0-9_x]/);
    });
  },
  Ee = function (e, n, t, r) {
    var o = e.createShader(35633 - t);
    o && n && (e.shaderSource(o, r), e.compileShader(o), e.attachShader(n, o));
  },
  Pe = ["rec2020", "p3", "srgb"],
  Oe = [
    "chrome",
    "safari",
    "__crWeb",
    "__gCrWeb",
    "yandex",
    "__yb",
    "__ybro",
    "__firefox__",
    "__edgeTrackingPreventionStatistics",
    "webkit",
    "oprt",
    "samsungAr",
    "ucweb",
    "UCShellJava",
    "puffinDevice",
  ],
  je = B,
  Le = {
    awesomium: "a",
    cef: "b",
    cefsharp: "c",
    coachjs: "d",
    fminer: "e",
    geb: "f",
    nightmarejs: "g",
    phantomas: "h",
    phantomjs: "i",
    rhino: "j",
    selenium: "k",
    webdriverio: "l",
    webdriver: "m",
    headless_chrome: "n",
  },
  Re = {
    awesomium: { window: ["awesomium"] },
    cef: { window: ["RunPerfTest"] },
    cefsharp: { window: ["CefSharp"] },
    coachjs: { window: ["emit"] },
    fminer: { window: ["fmget_targets"] },
    geb: { window: ["geb"] },
    nightmarejs: { window: ["__nightmare", "nightmare"] },
    phantomas: { window: ["__phantomas"] },
    phantomjs: { window: ["callPhantom", "_phantom"] },
    rhino: { window: ["spawn"] },
    selenium: {
      window: [
        "_Selenium_IDE_Recorder",
        "_selenium",
        "calledSelenium",
        /^([a-z]){3}_.*_(Array|Promise|Symbol)$/,
      ],
      document: [
        "__selenium_evaluate",
        "selenium-evaluate",
        "__selenium_unwrapped",
      ],
    },
    webdriverio: { window: ["wdioElectron"] },
    webdriver: {
      window: [
        "webdriver",
        "__webdriverFunc",
        "__lastWatirAlert",
        "__lastWatirConfirm",
        "__lastWatirPrompt",
        "_WEBDRIVER_ELEM_CACHE",
        "ChromeDriverw",
      ],
      document: [
        "__webdriver_script_fn",
        "__driver_evaluate",
        "__webdriver_evaluate",
        "__fxdriver_evaluate",
        "__driver_unwrapped",
        "__webdriver_unwrapped",
        "__fxdriver_unwrapped",
        "__webdriver_script_fn",
        "__webdriver_script_func",
        "__webdriver_script_function",
        "$cdc_asdjflasutopfhvcZLmcf",
        "$cdc_asdjflasutopfhvcZLmcfl_",
        "$chrome_asyncScriptInfo",
        "__$webdriverAsyncExecutor",
      ],
    },
    headless_chrome: { window: ["domAutomation", "domAutomationController"] },
  },
  Ce = function (e) {
    for (
      var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), r = 1;
      r < n;
      r++
    )
      t[r - 1] = arguments[r];
    var o,
      i = function (n) {
        if ("string" == typeof n) {
          if (((t = n), -1 !== e.indexOf(t))) return { v: !0 };
        } else if (
          void 0 !==
          (function (e, n) {
            if ("find" in e) return e.find(n);
            for (var t = 0; t < e.length; t++) if (n(e[t])) return e[t];
          })(e, function (e) {
            return n.test(e);
          })
        )
          return { v: !0 };
        var t;
      };
    for (var a of t) if ((o = i(a))) return o.v;
    return !1;
  },
  Ae = me;
function ke(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n &&
      (r = r.filter(function (n) {
        return Object.getOwnPropertyDescriptor(e, n).enumerable;
      })),
      t.push.apply(t, r);
  }
  return t;
}
function Ie(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2
      ? ke(Object(t), !0).forEach(function (n) {
          i(e, n, t[n]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ke(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
  }
  return e;
}
var xe = { method: "HEAD", mode: "no-cors" },
  Te = (function () {
    var e = n(function* (e, n) {
      var t,
        r,
        o = e.then(
          function (e) {
            t = [!0, e];
          },
          function (e) {
            t = [!1, e];
          }
        ),
        i = n.then(
          function (e) {
            r = [!0, e];
          },
          function (e) {
            r = [!1, e];
          }
        );
      return (
        yield Promise.race([o, i]),
        t
          ? t[0]
            ? Promise.resolve(t[1])
            : Promise.reject(t[1])
          : r
          ? r[0]
            ? Promise.resolve(r[1])
            : Promise.reject(r[1])
          : Promise.resolve(null)
      );
    });
    return function (n, t) {
      return e.apply(this, arguments);
    };
  })();
function Ne(e) {
  return (function (e, n) {
    for (
      var t =
          arguments.length > 2 && void 0 !== arguments[2]
            ? arguments[2]
            : Math.random,
        r = "",
        o = 0;
      o < e;
      o++
    )
      r += n.charAt(Math.floor(t() * n.length));
    return r;
  })(e, "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789");
}
var _e,
  Ve = window,
  De = navigator,
  { URLPattern: Me } = Ve,
  Fe =
    R([
      "union" in Set.prototype,
      "Iterator" in Ve,
      Me && "hasRegExpGroups" in Me.prototype,
      "RGB8" in WebGLRenderingContext.prototype,
    ]) >= 3,
  We =
    ((_e = Ve.print),
    /^function\s.*?\{\s*\[native code]\s*}$/.test(String(_e)) &&
      "[object WebPageNamespace]" === String(Ve.browser)),
  He =
    R([
      "DOMRectList" in Ve,
      "RTCPeerConnectionIceEvent" in Ve,
      "SVGGeometryElement" in Ve,
      "ontransitioncancel" in Ve,
    ]) >= 3,
  Ze =
    R([
      !("getStorageUpdates" in De),
      HTMLButtonElement && "popover" in HTMLButtonElement.prototype,
      "CSSCounterStyleRule" in Ve,
      CSS.supports("font-size-adjust: ex-height 0.5"),
      CSS.supports("text-transform: full-width"),
    ]) >= 4,
  Ge =
    R([
      !("MediaSettingsRange" in Ve),
      "RTCEncodedAudioFrame" in Ve,
      "[object Intl]" === "".concat(Ve.Intl),
      "[object Reflect]" === "".concat(Ve.Reflect),
    ]) >= 3,
  Be = (function () {
    var e = n(function* (e, n, t) {
      for (var r = document; !r.body; ) yield z(t);
      var o = r.createElement("iframe");
      try {
        for (
          yield new Promise(function (e, t) {
            var i = !1,
              a = function () {
                (i = !0), e();
              };
            (o.onload = a),
              (o.onerror = function (e) {
                (i = !0), t(e);
              });
            var { style: c } = o;
            c.setProperty("display", "block", "important"),
              (c.position = "absolute"),
              (c.top = "0"),
              (c.left = "0"),
              (c.visibility = "hidden"),
              n && ("srcdoc" in o) ? (o.srcdoc = n) : (o.src = "about:blank"),
              r.body.appendChild(o);
            var u = function () {
              var e, n;
              i ||
                ("complete" ===
                (null === (e = o.contentWindow) ||
                void 0 === e ||
                null === (n = e.document) ||
                void 0 === n
                  ? void 0
                  : n.readyState)
                  ? a()
                  : setTimeout(u, 10));
            };
            u();
          });
          null === (i = o.contentWindow) ||
          void 0 === i ||
          null === (a = i.document) ||
          void 0 === a ||
          !a.body;

        ) {
          var i, a;
          yield z(t);
        }
        return yield e(o, o.contentWindow);
      } finally {
        var c;
        null === (c = o.parentNode) || void 0 === c || c.removeChild(o);
      }
    });
    return function (n, t, r) {
      return e.apply(this, arguments);
    };
  })();
function Ye(e) {
  return (function (e) {
    for (
      var n,
        t = (function () {
          for (var e = new Uint32Array(256), n = 0; n < 256; n++) {
            for (var t = n, r = 0; r < 8; r++)
              t = 1 & t ? 3988292384 ^ (t >>> 1) : t >>> 1;
            e[n] = t;
          }
          return e;
        })(),
        r =
          (n = e) instanceof ArrayBuffer
            ? new Uint8Array(n)
            : new Uint8Array(n.buffer, n.byteOffset, n.byteLength),
        o = -1,
        i = 0;
      i < r.length;
      i++
    )
      o = (o >>> 8) ^ t[255 & (o ^ r[i])];
    return ~o >>> 0;
  })(
    (function (e) {
      for (var n = new Uint8Array(e.length), t = 0; t < e.length; t++) {
        var r = e.charCodeAt(t);
        if (r > 127) return new TextEncoder().encode(e);
        n[t] = r;
      }
      return n;
    })(e)
  );
}
function Xe(e, n) {
  var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
    r =
      e[
        (function (e, n, t) {
          for (var r = e; r; ) {
            for (
              var o = Object.getOwnPropertyNames(r), i = 0;
              i < o.length;
              i++
            ) {
              var a = o[i];
              if (Ye(a) === n) return t && console.log("propName: ", a, n), a;
            }
            r = Object.getPrototypeOf(r);
          }
          return "";
        })(e, n, t)
      ];
  return (
    t && console.log("findProp: ", r, n, e),
    "function" == typeof r ? r.bind(e) : r
  );
}
function ze(e, n, t) {
  var r;
  return e
    ? (null === (r = e.parentNode) || void 0 === r || r.replaceChild(n, e),
      "function" != typeof t || t())
    : null;
}
function Je(e) {
  for (
    var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), r = 1;
    r < n;
    r++
  )
    t[r - 1] = arguments[r];
  var o = document.createElement("template");
  return (
    (o.innerHTML = e
      .map(function (e, n) {
        return "".concat(e).concat(t[n] || "");
      })
      .join("")),
    document.importNode(o.content, !0)
  );
}
var Ue,
  Ke =
    "\n\t'Segoe Fluent Icons',\n\t'Ink Free',\n\t'Bahnschrift',\n\t'Segoe MDL2 Assets',\n\t'HoloLens MDL2 Assets',\n\t'Leelawadee UI',\n\t'Javanese Text',\n\t'Segoe UI Emoji',\n\t'Aldhabi',\n\t'Gadugi',\n\t'Myanmar Text',\n\t'Nirmala UI',\n\t'Lucida Console',\n\t'Cambria Math',\n\t'Bai Jamjuree',\n\t'Chakra Petch',\n\t'Charmonman',\n\t'Fahkwang',\n\t'K2D',\n\t'Kodchasan',\n\t'KoHo',\n\t'Sarabun',\n\t'Srisakdi',\n\t'Galvji',\n\t'MuktaMahee Regular',\n\t'InaiMathi Bold',\n\t'American Typewriter Semibold',\n\t'Futura Bold',\n\t'SignPainter-HouseScript Semibold',\n\t'PingFang HK Light',\n\t'Kohinoor Devanagari Medium',\n\t'Luminari',\n\t'Geneva',\n\t'Helvetica Neue',\n\t'Droid Sans Mono',\n\t'Dancing Script',\n\t'Roboto',\n\t'Ubuntu',\n\t'Liberation Mono',\n\t'Source Code Pro',\n\t'DejaVu Sans',\n\t'OpenSymbol',\n\t'Chilanka',\n\t'Cousine',\n\t'Arimo',\n\t'Jomolhari',\n\t'MONO',\n\t'Noto Color Emoji',\n\tsans-serif !important\n",
  Qe = [
    [128512],
    [9786],
    [129333, 8205, 9794, 65039],
    [9832],
    [9784],
    [9895],
    [8265],
    [8505],
    [127987, 65039, 8205, 9895, 65039],
    [129394],
    [9785],
    [9760],
    [129489, 8205, 129456],
    [129487, 8205, 9794, 65039],
    [9975],
    [129489, 8205, 129309, 8205, 129489],
    [9752],
    [9968],
    [9961],
    [9972],
    [9992],
    [9201],
    [9928],
    [9730],
    [9969],
    [9731],
    [9732],
    [9976],
    [9823],
    [9937],
    [9e3],
    [9993],
    [9999],
    [128105, 8205, 10084, 65039, 8205, 128139, 8205, 128104],
    [128104, 8205, 128105, 8205, 128103, 8205, 128102],
    [128104, 8205, 128105, 8205, 128102],
    [128512],
    [169],
    [174],
    [8482],
    [128065, 65039, 8205, 128488, 65039],
    [10002],
    [9986],
    [9935],
    [9874],
    [9876],
    [9881],
    [9939],
    [9879],
    [9904],
    [9905],
    [9888],
    [9762],
    [9763],
    [11014],
    [8599],
    [10145],
    [11013],
    [9883],
    [10017],
    [10013],
    [9766],
    [9654],
    [9197],
    [9199],
    [9167],
    [9792],
    [9794],
    [10006],
    [12336],
    [9877],
    [9884],
    [10004],
    [10035],
    [10055],
    [9724],
    [9642],
    [10083],
    [10084],
    [9996],
    [9757],
    [9997],
    [10052],
    [9878],
    [8618],
    [9775],
    [9770],
    [9774],
    [9745],
    [10036],
    [127344],
    [127359],
  ].map(function (e) {
    return String.fromCodePoint.apply(String, p(e));
  }),
  qe = function () {
    for (var e = 0, n = arguments.length, t = new Array(n), r = 0; r < n; r++)
      t[r] = arguments[r];
    for (var o = 0; o < t.length; o += 1) e += t[o].length;
    for (var i = Array(e), a = 0, c = 0; c < t.length; c += 1)
      for (var u = t[c], l = 0; l < u.length; l += 1) (i[a] = u[l]), (a += 1);
    return i;
  },
  $e = ["monospace", "sans-serif", "serif"],
  en = [
    "sans-serif-thin",
    "ARNO PRO",
    "Agency FB",
    "Arabic Typesetting",
    "Arial Unicode MS",
    "AvantGarde Bk BT",
    "BankGothic Md BT",
    "Batang",
    "Bitstream Vera Sans Mono",
    "Calibri",
    "Century",
    "Century Gothic",
    "Clarendon",
    "EUROSTILE",
    "Franklin Gothic",
    "Futura Bk BT",
    "Futura Md BT",
    "GOTHAM",
    "Gill Sans",
    "HELV",
    "Haettenschweiler",
    "Helvetica Neue",
    "Humanst521 BT",
    "Leelawadee",
    "Letter Gothic",
    "Levenim MT",
    "Lucida Bright",
    "Lucida Sans",
    "Menlo",
    "MS Mincho",
    "MS Outlook",
    "MS Reference Specialty",
    "MS UI Gothic",
    "MT Extra",
    "MYRIAD PRO",
    "Marlett",
    "Meiryo UI",
    "Microsoft Uighur",
    "Minion Pro",
    "Monotype Corsiva",
    "PMingLiU",
    "Pristina",
    "SCRIPTINA",
    "Segoe UI Light",
    "Serifa",
    "SimHei",
    "Small Fonts",
    "Staccato222 BT",
    "TRAJAN PRO",
    "Univers CE 55 Medium",
    "Vrinda",
    "ZWAdobeF",
  ],
  nn = 4191585516,
  tn = new Set([
    4106781067,
    3209949814,
    2612078219,
    2382064880,
    3225112721,
    1018714844,
    2899793226,
    2094258580,
    3169460974,
    3079760821,
    392195965,
    3461410589,
    3582327722,
    1731918890,
    1767246934,
    3419607467,
    1110225616,
    1455947556,
    450291099,
    176445009,
    1998723369,
    2961538051,
    3413933903,
    2299562828,
    3945560591,
    485550147,
    3336694844,
    3737152292,
    2669437517,
    3860417393,
    nn,
  ]),
  rn = function (e) {
    var n =
        arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "intl",
      t = null;
    try {
      t = e();
    } catch (e) {
      t = "".concat(n, " error");
    }
    return t;
  },
  on = { unknown: "a", granted: "b", prompt: "c", denied: "d" };
function an(e, n) {
  return (
    n || (n = e.slice(0)),
    Object.freeze(
      Object.defineProperties(e, { raw: { value: Object.freeze(n) } })
    )
  );
}
var cn = "a",
  un = "b",
  ln = "c",
  sn = "d",
  dn = "e",
  fn = {
    7: ["Cambria Math", "Lucida Console"],
    8: ["Aldhabi", "Gadugi", "Myanmar Text", "Nirmala UI"],
    8.1: ["Leelawadee UI", "Javanese Text", "Segoe UI Emoji"],
    10: [
      "HoloLens MDL2 Assets",
      "Segoe MDL2 Assets",
      "Bahnschrift",
      "Ink Free",
    ],
    11: ["Segoe Fluent Icons"],
  },
  mn = {
    10.9: ["Helvetica Neue", "Geneva"],
    "10.10": ["Kohinoor Devanagari Medium", "Luminari"],
    10.11: ["PingFang HK Light"],
    10.12: [
      "American Typewriter Semibold",
      "Futura Bold",
      "SignPainter-HouseScript Semibold",
    ],
    "10.13-10.14": ["InaiMathi Bold"],
    "10.15-11": ["Galvji", "MuktaMahee Regular"],
    12: [
      "Noto Sans Gunjala Gondi Regular",
      "Noto Sans Masaram Gondi Regular",
      "Noto Serif Yezidi Regular",
    ],
    13: [
      "Apple SD Gothic Neo ExtraBold",
      "STIX Two Math Regular",
      "STIX Two Text Regular",
      "Noto Sans Canadian Aboriginal Regular",
    ],
  },
  vn = {
    "Microsoft Outlook": ["MS Outlook"],
    "Adobe Acrobat": ["ZWAdobeF"],
    LibreOffice: ["Amiri", "KACSTOffice", "Liberation Mono", "Source Code Pro"],
    OpenOffice: ["DejaVu Sans", "Gentium Book Basic", "OpenSymbol"],
  },
  pn = Object.keys(mn)
    .map(function (e) {
      return mn[e];
    })
    .flat(),
  hn = Object.keys(fn)
    .map(function (e) {
      return fn[e];
    })
    .flat(),
  yn = Object.keys(vn)
    .map(function (e) {
      return vn[e];
    })
    .flat(),
  gn = []
    .concat(
      p(pn),
      p(hn),
      [
        "Arimo",
        "Chilanka",
        "Cousine",
        "Jomolhari",
        "MONO",
        "Noto Color Emoji",
        "Ubuntu",
      ],
      ["Dancing Script", "Droid Sans Mono", "Roboto"],
      p(yn)
    )
    .sort(),
  bn = (function () {
    var e = n(function* (e) {
      try {
        var n = [];
        document.fonts.check('0px "'.concat(re(), '"')) ||
          (n = e.reduce(function (e, n) {
            return document.fonts.check('0px "'.concat(n, '"')) && e.push(n), e;
          }, []));
        var t = e.map(function (e) {
            return new FontFace(e, 'local("'.concat(e, '")'));
          }),
          r = (yield Promise.allSettled(
            t.map(function (e) {
              return e.load();
            })
          )).reduce(function (e, n) {
            return "fulfilled" == n.status && e.push(n.value.family), e;
          }, []);
        return p(new Set([].concat(p(n), p(r)))).sort();
      } catch (e) {
        return [];
      }
    });
    return function (n) {
      return e.apply(this, arguments);
    };
  })(),
  wn = [
    ["navigator", ["plugins", "userAgent", "platform", "appName", "languages"]],
    ["screen", ["width", "availWidth", "height", "availHeight"]],
  ],
  Sn = "a",
  En = "b",
  Pn = "c",
  On = "d",
  jn = new Set([2882888216, 2306836488, 1040191956, 1447924955]),
  Ln = function (e) {
    var n = function (e) {
      return e.replace(/([,\\])/g, "\\$1");
    };
    return e
      .map(function (e) {
        return [
          n(e.voiceURI),
          n(e.name),
          n(e.lang),
          e.localService ? "1" : "0",
          e.default ? "1" : "0",
        ].join(",");
      })
      .sort();
  },
  Rn = "a",
  Cn = "b",
  An = "c",
  kn = "d",
  In = {
    brands: "a",
    uaFullVersion: "b",
    platform: "c",
    platformVersion: "d",
    architecture: "e",
    bitness: "f",
    fullVersionList: "g",
    mobile: "h",
    model: "i",
  },
  xn = [
    "brands",
    "mobile",
    "platform",
    "platformVersion",
    "architecture",
    "bitness",
    "model",
    "uaFullVersion",
    "fullVersionList",
  ],
  Tn = "timeout",
  Nn = "suspended";
function _n(e) {
  var n = new Error(e);
  return (n.name = e), n;
}
var Vn,
  Dn,
  Mn,
  Fn,
  Wn = "unsupported",
  Hn = "unstable",
  Zn = function (e) {
    return e.toDataURL();
  },
  Gn = function (e) {
    return (
      e.rect(0, 0, 10, 10),
      e.rect(2, 2, 6, 6),
      !e.isPointInPath(5, 5, "evenodd")
    );
  },
  Bn = "a",
  Yn = "b",
  Xn = "c",
  zn = "d",
  Jn = function (e) {
    var n = Number(e);
    return Number.isNaN(n) ? -1 : n;
  },
  Un = function (e) {
    return !(
      !e ||
      "object" != typeof e ||
      (((!_ && !V) ||
        ("Error" !== e.name && "TypeError" !== e.name) ||
        "Permission denied" !== e.message) &&
        "SecurityError" !== e.name)
    );
  },
  Kn = function (e) {
    return "UnknownError" === e.name && /out of memory/.test(e.message);
  },
  Qn = new Promise(
    (function () {
      var e = n(function* (e, n) {
        var t;
        if (
          M &&
          W &&
          null !== (t = navigator.storage) &&
          void 0 !== t &&
          t.getDirectory
        ) {
          var r,
            o,
            i = "sgn-root-directory";
          try {
            if ((r = yield navigator.storage.getDirectory())) {
              try {
                yield r.removeEntry(i, { recursive: !0 });
              } catch (e) {}
              o = yield r.getDirectoryHandle(i, { create: !0 });
              for (var a = 0, c = o, u = 0; u < 12; u++)
                try {
                  c = yield o.getDirectoryHandle(Ne(255), { create: !0 });
                  try {
                    yield o.move(c, Ne(255));
                  } catch (e) {
                    if (!Kn(e)) throw e;
                    break;
                  }
                  a++;
                } catch (e) {
                  Kn(e) || n(e);
                }
              var l = 255,
                s = 0;
              try {
                var d = yield c.getDirectoryHandle("d", { create: !0 });
                if (!d) {
                  try {
                    yield r.removeEntry(i, { recursive: !0 });
                  } catch (e) {}
                  return e({ a: a, b: s });
                }
                for (; l - s > 1; ) {
                  var f = Math.floor((s + l) / 2);
                  try {
                    yield d.move(c, Ne(f));
                  } catch (e) {
                    Kn(e) || n(e), (l = f);
                  }
                  s = f;
                }
                yield r.removeEntry(i, { recursive: !0 }), e({ a: a, b: s });
              } catch (e) {
                Kn(e) || n(e);
              }
            } else e(null);
          } catch (e) {
            n(e);
          }
        } else e(null);
      });
      return function (n, t) {
        return e.apply(this, arguments);
      };
    })()
  ),
  qn = function (e) {
    for (var n = 0; n < 4; n += 1) if (e[n]) return !1;
    return !0;
  },
  $n = function () {
    var e = window.screen;
    return [
      L(O(e.availTop), null),
      L(O(e.width) - O(e.availWidth) - L(O(e.availLeft), 0), null),
      L(O(e.height) - O(e.availHeight) - L(O(e.availTop), 0), null),
      L(O(e.availLeft), null),
    ];
  },
  et =
    ((function () {
      if (void 0 === Dn) {
        var e = function () {
          var n = $n();
          qn(n) ? (Dn = setTimeout(e, 2500)) : ((Vn = n), (Dn = void 0));
        };
        e();
      }
    })(),
    n(function* () {
      var e,
        n = $n();
      if (qn(n)) {
        if (Vn) return p(Vn);
        ((e = document).fullscreenElement ||
          e.msFullscreenElement ||
          e.mozFullScreenElement ||
          e.webkitFullscreenElement) &&
          (yield (function () {
            var e = document;
            return (
              e.exitFullscreen ||
              e.msExitFullscreen ||
              e.mozCancelFullScreen ||
              e.webkitExitFullscreen
            ).call(e);
          })(),
          (n = $n()));
      }
      return qn(n) || (Vn = n), n;
    })),
  nt = function (e) {
    return null === e
      ? null
      : (function (e) {
          var n =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          if (Math.abs(n) >= 1) return Math.round(e / n) * n;
          var t = 1 / n;
          return Math.round(e * t) / t;
        })(e, 10);
  },
  tt = function (e) {
    return {
      bottom: e.bottom,
      height: e.height,
      left: e.left,
      right: e.right,
      width: e.width,
      top: e.top,
      x: e.x,
      y: e.y,
    };
  },
  rt = function () {
    try {
      var e = document.createElement("iframe");
      document.body.appendChild(e);
      var n = e.contentWindow,
        t = Object.getOwnPropertyNames(window),
        r = Object.getOwnPropertyNames(n);
      return (
        document.body.removeChild(e),
        t.filter(function (e) {
          return !r.includes(e);
        })
      );
    } catch (e) {
      return [];
    }
  },
  ot = function () {
    var e = Object.getOwnPropertyNames(window).slice(-50),
      [n, t] = (1).constructor.toString().split((1).constructor.name);
    return Object.keys(window)
      .slice(-50)
      .filter(function (r) {
        return (function (r) {
          if (/_$/.test(r)) return !0;
          var o,
            i = Object.getOwnPropertyDescriptor(window, r);
          return (
            !i ||
            ("chrome" === r
              ? e.includes(r)
              : !(
                  "function" == typeof (o = i.get || i.value) &&
                  ("" + o === n + o.name + t ||
                    "" + o === n + (o.name || "").replace("get ", "") + t)
                ))
          );
        })(r);
      });
  },
  it = (function () {
    var e = n(function* () {
      return "getBattery" in navigator &&
        "function" == typeof navigator.getBattery
        ? navigator.getBattery()
        : null;
    });
    return function () {
      return e.apply(this, arguments);
    };
  })();
function at(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n &&
      (r = r.filter(function (n) {
        return Object.getOwnPropertyDescriptor(e, n).enumerable;
      })),
      t.push.apply(t, r);
  }
  return t;
}
function ct(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2
      ? at(Object(t), !0).forEach(function (n) {
          i(e, n, t[n]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : at(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
  }
  return e;
}
var ut = function (e) {
    return Object.keys(e.__proto__).reduce(function (n, t) {
      var r = e[t];
      return isNaN(r) ? n : (n += r);
    }, 0);
  },
  lt = "mmMwWLliI0fiflO&1",
  st = {
    default: "a",
    apple: "b",
    serif: "c",
    sans: "d",
    mono: "e",
    min: "f",
    system: "g",
  },
  dt = {
    default: [],
    apple: [{ font: "-apple-system-body" }],
    serif: [{ fontFamily: "serif" }],
    sans: [{ fontFamily: "sans-serif" }],
    mono: [{ fontFamily: "monospace" }],
    min: [{ fontSize: "1px" }],
    system: [{ fontFamily: "system-ui" }],
  },
  ft = function () {
    return 0;
  },
  mt = function (e) {
    e.style.setProperty("visibility", "hidden", "important"),
      e.style.setProperty("display", "block", "important");
  },
  vt = (function () {
    var e = n(function* (e) {
      var n = document,
        t = n.createElement("div"),
        r = new Array(e.length),
        o = {};
      mt(t);
      for (var i = 0; i < e.length; i += 1) {
        var a = $(e[i]);
        "DIALOG" === a.tagName && a.show();
        var c = n.createElement("div");
        mt(c), c.appendChild(a), t.appendChild(c), (r[i] = a);
      }
      for (; !n.body; ) yield z(50);
      n.body.appendChild(t);
      try {
        for (var u = 0; u < e.length; u += 1)
          r[u].offsetParent || (o[e[u]] = !0);
      } finally {
        var l;
        null === (l = t.parentNode) || void 0 === l || l.removeChild(t);
      }
      return o;
    });
    return function (n) {
      return e.apply(this, arguments);
    };
  })(),
  pt = {
    aav: function () {
      return new Promise(function (e, n) {
        try {
          Promise.all([
            it(),
            p(new Set([].concat(p(rt()), p(ot()))))
              .sort()
              .slice(0, 50),
          ])
            .then(
              function (n) {
                var [t, r] = n,
                  o = null,
                  i = null,
                  a = null,
                  c = null;
                t &&
                  ((o = t.charging),
                  (i = t.chargingTime),
                  (a = t.dischargingTime),
                  (c = t.level));
                var u = {
                  a: t
                    ? {
                        a: o,
                        b: t.chargingTime === 1 / 0 ? -1 : i,
                        c: a === 1 / 0 ? -1 : a,
                        d: c,
                      }
                    : null,
                  b: r,
                };
                e(u);
              },
              function (e) {
                n(e);
              }
            )
            .catch(function (e) {
              n(e);
            });
        } catch (e) {
          n(e);
        }
      });
    },
    aaq: function () {
      return new Promise(function (e, n) {
        try {
          var t =
              ne["Element.getClientRects"] ||
              ne["Element.getBoundingClientRect"] ||
              ne["Range.getClientRects"] ||
              ne["Range.getBoundingClientRect"] ||
              ne["String.fromCodePoint"] ||
              !1,
            r = oe && oe.document && oe.document.body ? oe.document : document,
            o = "".concat(ae, "-client-rects-div"),
            i = document.createElement("div");
          i.setAttribute("id", o),
            r.body.appendChild(i),
            ze(
              i,
              Je(
                Mn ||
                  (Mn = an([
                    '\n        <div id="',
                    '">\n          <style>\n          .rect-ghost,\n          .rect-known {\n            top: 0;\n            left: 0;\n            position: absolute;\n            visibility: hidden;\n          }\n          .rect-known {\n            width: 100px;\n            height: 100px;\n            transform: rotate(45deg);\n          }\n          .rect-ghost {\n            width: 0;\n            height: 0;\n          }\n          </style>\n          <div class="rect-known"></div>\n          <div class="rect-ghost"></div>\n          <div style="perspective:100px;width:1000.099%;" id="rect-container">\n            <style>\n            .rects {\n              width: 1000%;\n              height: 1000%;\n              max-width: 1000%;\n            }\n            .absolute {\n              position: absolute;\n            }\n            #cRect1 {\n              border: solid 2.715px;\n              border-color: #F72585;\n              padding: 3.98px;\n              margin-left: 12.12px;\n            }\n            #cRect2 {\n              border: solid 2px;\n              border-color: #7209B7;\n              font-size: 30px;\n              margin-top: 20px;\n              padding: 3.98px;\n              transform: skewY(23.1753218deg) rotate3d(10.00099, 90, 0.100000000000009, 60000000000008.00000009deg);\n            }\n            #cRect3 {\n              border: solid 2.89px;\n              border-color: #3A0CA3;\n              font-size: 45px;\n              transform: skewY(-23.1753218deg) scale(1099.0000000099, 1.89) matrix(1.11, 2.0001, -1.0001, 1.009, 150, 94.4);\n              margin-top: 50px;\n            }\n            #cRect4 {\n              border: solid 2px;\n              border-color: #4361EE;\n              transform: matrix(1.11, 2.0001, -1.0001, 1.009, 150, 94.4);\n              margin-top: 11.1331px;\n              margin-left: 12.1212px;\n              padding: 4.4545px;\n              left: 239.4141px;\n              top: 8.5050px;\n            }\n            #cRect5 {\n              border: solid 2px;\n              border-color: #4CC9F0;\n              margin-left: 42.395pt;\n            }\n            #cRect6 {\n              border: solid 2px;\n              border-color: #F72585;\n              transform: perspective(12890px) translateZ(101.5px);\n              padding: 12px;\n            }\n            #cRect7 {\n              margin-top: -350.552px;\n              margin-left: 0.9099rem;\n              border: solid 2px;\n              border-color: #4361EE;\n            }\n            #cRect8 {\n              margin-top: -150.552px;\n              margin-left: 15.9099rem;\n              border: solid 2px;\n              border-color: #3A0CA3;\n            }\n            #cRect9 {\n              margin-top: -110.552px;\n              margin-left: 15.9099rem;\n              border: solid 2px;\n              border-color: #7209B7;\n            }\n            #cRect10 {\n              margin-top: -315.552px;\n              margin-left: 15.9099rem;\n              border: solid 2px;\n              border-color: #F72585;\n            }\n            #cRect11 {\n              width: 10px;\n              height: 10px;\n              margin-left: 15.0000009099rem;\n              border: solid 2px;\n              border-color: #F72585;\n            }\n            #cRect12 {\n              width: 10px;\n              height: 10px;\n              margin-left: 15.0000009099rem;\n              border: solid 2px;\n              border-color: #F72585;\n            }\n            #rect-container .shift-dom-rect {\n              top: 1px !important;\n              left: 1px !important;\n            }\n            </style>\n            <div id="cRect1" class="rects"></div>\n            <div id="cRect2" class="rects"></div>\n            <div id="cRect3" class="rects"></div>\n            <div id="cRect4" class="rects absolute"></div>\n            <div id="cRect5" class="rects"></div>\n            <div id="cRect6" class="rects"></div>\n            <div id="cRect7" class="rects absolute"></div>\n            <div id="cRect8" class="rects absolute"></div>\n            <div id="cRect9" class="rects absolute"></div>\n            <div id="cRect10" class="rects absolute"></div>\n            <div id="cRect11" class="rects"></div>\n            <div id="cRect12" class="rects"></div>\n            <div id="emoji" class="emojis"></div>\n          </div>\n          <div id="emoji-container">\n            <style>\n            .domrect-emoji {\n              font-family: ',
                    ";\n              font-size: 200px !important;\n              height: auto;\n              position: absolute !important;\n              transform: scale(1.000999);\n            }\n            </style>\n            ",
                    "\n          </div>\n        </div>\n      ",
                  ])),
                o,
                Ke,
                Qe.map(function (e) {
                  return '<div class="domrect-emoji">'.concat(e, "</div>");
                }).join("")
              )
            );
          var a = new Set(),
            c = p(r.getElementsByClassName("domrect-emoji")).reduce(function (
              e,
              n,
              t
            ) {
              var o = Qe[t],
                { height: i, width: c } = (function (e, n) {
                  var t;
                  return ne["Element.getClientRects"]
                    ? ne["Element.getBoundingClientRect"]
                      ? ne["Range.getClientRects"]
                        ? ((t = n.createRange()).selectNode(e),
                          t.getBoundingClientRect())
                        : ((t = n.createRange()).selectNode(e),
                          t.getClientRects()[0])
                      : e.getBoundingClientRect()
                    : e.getClientRects()[0];
                })(n, r),
                u = "".concat(c, ",").concat(i);
              return a.has(u) || (a.add(u), e.add(o)), e;
            },
            new Set()),
            u =
              1e-5 *
              p(a)
                .map(function (e) {
                  return e.split(",").reduce(function (e, n) {
                    return e + (+n || 0);
                  }, 0);
                })
                .reduce(function (e, n) {
                  return e + n;
                }, 0),
            l = document.createRange(),
            s = r.getElementsByClassName("rects"),
            d = p(s).map(function (e) {
              return tt(e.getClientRects()[0]);
            }),
            f = p(s).map(function (e) {
              return tt(e.getBoundingClientRect());
            }),
            m = p(s).map(function (e) {
              return l.selectNode(e), tt(l.getClientRects()[0]);
            }),
            v = p(s).map(function (e) {
              return l.selectNode(e), tt(e.getBoundingClientRect());
            }),
            h = p(s)[3],
            { top: y } = d[3];
          h.classList.add("shift-dom-rect");
          var { top: g } = tt(h.getClientRects()[0]);
          h.classList.remove("shift-dom-rect");
          var { top: b } = tt(h.getClientRects()[0]);
          y - g != b - g && (t = !0),
            d.forEach(function (e) {
              var {
                right: n,
                left: r,
                width: o,
                bottom: i,
                top: a,
                height: c,
                x: u,
                y: l,
              } = e;
              (n - r == o && i - a == c && n - u == o && i - l == c) ||
                (t = !0);
            });
          var { right: w, left: S } = d[10],
            { right: E, left: P } = d[11];
          (w == E && S == P) || (t = !0);
          var O = p(r.getElementsByClassName("rect-known"))[0],
            j =
              ((A = tt(O.getClientRects()[0])),
              (
                "0000000" +
                (
                  (k = "".concat(JSON.stringify(A)))
                    .split("")
                    .reduce(function (e, n, t) {
                      return (Math.imul(31, e) + k.charCodeAt(t)) | 0;
                    }, 2166136261) >>> 0
                ).toString(16)
              ).substr(-8));
          D
            ? { "9d9215cc": !0, "47ded322": !0, d0eceaa8: !0 }[j] || (t = !0)
            : Z && ({ e38453f0: !0 }[j] || (t = !0));
          var L = p(r.getElementsByClassName("rect-ghost"))[0],
            R = tt(L.getClientRects()[0]);
          Object.keys(R).some(function (e) {
            return 0 !== R[e];
          }) && (t = !0),
            r.body.removeChild(r.getElementById(o));
          var C = {
            elementClientRects: d,
            elementBoundingClientRect: f,
            rangeClientRects: m,
            rangeBoundingClientRect: v,
            emojiSet: p(c),
            domrectSystemSum: u,
            lied: t,
          };
          t
            ? n("dom rects lied")
            : ee(C).then(
                function (n) {
                  e(n);
                },
                function (e) {
                  n(e);
                }
              );
        } catch (e) {
          n(e);
        }
        var A, k;
      });
    },
    aat: function () {
      return new Promise(function (e) {
        ("bluetooth" in navigator &&
          navigator.bluetooth &&
          navigator.bluetooth.getAvailability) ||
          e(null),
          navigator.bluetooth.getAvailability().then(function (n) {
            e(n);
          });
      });
    },
    au: function () {
      var e = window.performance;
      if (e && e.now) {
        for (var n = 1, t = 1, r = e.now(), o = r, i = 0; i < 5e4; i += 1)
          if ((r = o) < (o = e.now())) {
            var a = o - r;
            a > n ? a < t && (t = a) : a < n && ((t = n), (n = a));
          }
        return [n, t];
      }
      return null;
    },
    l: function () {
      for (var e, n, t = [], r = window; ; )
        try {
          var o;
          (e = r.location), (n = r.document);
          var i = null == e ? void 0 : e.href,
            a = null == n ? void 0 : n.referrer;
          if (void 0 === i || void 0 === a) return Promise.resolve(t);
          t.push({ a: i, b: a });
          var c = null === (o = r) || void 0 === o ? void 0 : o.parent;
          if (!c || c === r) return t;
          r = c;
        } catch (e) {
          return Un(e) ? t : null;
        }
    },
    a: function () {
      var e = window.location,
        { origin: n } = e,
        t = e.origin,
        { ancestorOrigins: r } = e,
        o = [];
      if (r) {
        o = Array(r.length);
        for (var i = 0; i < r.length; i += 1) o[i] = r[i];
      }
      return { a: n || null, b: t || null, c: o };
    },
    p: function () {
      return Te(ce(450, null), Qn).then(function (e) {
        if ("object" != typeof e) throw new Error(JSON.stringify(e));
        return e;
      });
    },
    aw: function () {
      return new Promise(function (e, n) {
        try {
          et()
            .then(function (n) {
              e([nt(n[0]), nt(n[1]), nt(n[2]), nt(n[3])]);
            })
            .catch(function (e) {
              n(e);
            });
        } catch (e) {
          n(e);
        }
      });
    },
    acs: function () {
      return Z ? "getBattery" in navigator : null;
    },
    aah: function () {
      return new Promise(
        (function () {
          var e = n(function* (e, t) {
            var r = (function () {
              var e = n(function* (e) {
                var n =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : 4e3;
                return yield Be(function (t, r) {
                  var o = r.document,
                    i = o.body,
                    a = i.style;
                  (a.width = "".concat(n, "px")),
                    (a.webkitTextSizeAdjust = a.textSizeAdjust = "none"),
                    D
                      ? (i.style.zoom = "".concat(1 / r.devicePixelRatio))
                      : M && (i.style.zoom = "reset");
                  var c = o.createElement("div");
                  return (
                    (c.textContent = p(Array((n / 20) | 0))
                      .map(function () {
                        return "word";
                      })
                      .join(" ")),
                    i.appendChild(c),
                    e(o, i)
                  );
                }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
              });
              return function (n) {
                return e.apply(this, arguments);
              };
            })();
            yield r(function (n, t) {
              var r = {},
                o = {};
              Object.keys(dt).forEach(function (e) {
                var [o = {}, i = lt] = dt[e],
                  a = n.createElement("span");
                (a.textContent = i),
                  (a.style.whiteSpace = "nowrap"),
                  Object.keys(o).forEach(function (e) {
                    var n = o[e];
                    void 0 !== n && (a.style[e] = n);
                  }),
                  (r[e] = a),
                  t.append(n.createElement("br"), a);
              }),
                Object.keys(dt).forEach(function (e) {
                  o[st[e] || e] = r[e].getBoundingClientRect().width;
                }),
                e(o);
            });
          });
          return function (n, t) {
            return e.apply(this, arguments);
          };
        })()
      );
    },
    x: function () {
      var e = null;
      return (
        P("inverted-colors", "inverted") && (e = !0),
        P("inverted-colors", "none") && (e = !1),
        e
      );
    },
    aar: function () {
      return new Promise(function (e, n) {
        try {
          var t =
              oe && oe.document && oe.document.body ? oe.document : document,
            r = document.createElement("div");
          t.body.appendChild(r),
            ze(
              r,
              Je(
                Fn ||
                  (Fn = an([
                    '\n        <div id="svg-container">\n          <style>\n          #svg-container {\n            position: absolute;\n            left: -9999px;\n            height: auto;\n          }\n          #svg-container .shift-svg {\n            transform: scale(1.000999) !important;\n          }\n          .svgrect-emoji {\n            font-family: ',
                    ';\n            font-size: 200px !important;\n            height: auto;\n            position: absolute !important;\n            transform: scale(1.000999);\n          }\n          </style>\n          <svg>\n            <g id="svgBox">\n              ',
                    "\n            </g>\n          </svg>\n        </div>\n      ",
                  ])),
                Ke,
                Qe.map(function (e) {
                  return '<text x="32" y="32" class="svgrect-emoji">'.concat(
                    e,
                    "</text>"
                  );
                }).join("")
              )
            );
          var o = t.getElementById("svgBox"),
            i =
              ((g = o.getBBox()),
              Object.keys(g.__proto__).reduce(function (e, n) {
                var t = g[n];
                return "function" == typeof t
                  ? e
                  : ct(ct({}, e), {}, { [n]: t });
              }, {})),
            a = new Set(),
            c = p(o.getElementsByClassName("svgrect-emoji")),
            u = c.reduce(function (e, n, t) {
              var r = Qe[t],
                o = "" + n.getComputedTextLength();
              return a.has(o) || (a.add(o), e.add(r)), e;
            }, new Set()),
            l =
              1e-5 *
              p(a)
                .map(function (e) {
                  return e.split(",").reduce(function (e, n) {
                    return e + (+n || 0);
                  }, 0);
                })
                .reduce(function (e, n) {
                  return e + n;
                }, 0),
            s = c[0],
            d = s.getComputedTextLength();
          s.classList.add("shift-svg");
          var f = s.getComputedTextLength();
          s.classList.remove("shift-svg");
          var m = s.getComputedTextLength(),
            v = !1;
          d - f != m - f && (v = !0);
          var h = {
            bBox:
              ((y = i),
              y
                ? Object.keys(y).reduce(function (e, n) {
                    return e + Math.abs(y[n]);
                  }, 0)
                : 0),
            extentOfChar: ut(c[0].getExtentOfChar(Qe[0])),
            subStringLength: c[0].getSubStringLength(0, 10),
            computedTextLength: c[0].getComputedTextLength(),
            emojiSet: p(u),
            svgrectSystemSum: l,
          };
          v
            ? n(new Error("svg lied"))
            : ee(h)
                .then(function (n) {
                  return e(n);
                })
                .catch(function (n) {
                  return e(n.message || "svg hash error");
                });
        } catch (e) {
          n(e);
        }
        var y, g;
      });
    },
    as: function () {
      var e = navigator.plugins,
        n = [];
      if (e)
        for (var t = 0; t < e.length; t += 1) {
          var r = e[t];
          if (r) {
            for (var o = [], i = 0; i < r.length; i += 1) {
              var a = r[i];
              o.push({ a: a.type, b: a.suffixes });
            }
            n.push({ a: r.name, b: r.description, c: o });
          }
        }
      else n = null;
      return n;
    },
    abu: function () {
      return {
        [Bn]: window.outerWidth,
        [Yn]: window.outerHeight,
        [Xn]: window.innerWidth,
        [zn]: window.innerHeight,
      };
    },
    r: function () {
      var e = Date.now();
      return [Jn(e), Jn(e - 6e4 * new Date().getTimezoneOffset())];
    },
    abc: function () {
      return new Promise(function (e, n) {
        try {
          Promise.allSettled([
            new FontFace("lm", "local('Liberation Mono')").load(),
            new FontFace("ncm", "local('Noto Color Emoji')").load(),
          ])
            .then(function (n) {
              var [t, r] = n;
              e(!t && r ? -1 : t && !r ? 1 : t && r ? 2 : 0);
            })
            .catch(function (n) {
              e(null);
            });
        } catch (e) {
          n(e);
        }
      });
    },
    abm: function () {
      return void 0 === navigator.connection
        ? -1
        : void 0 === navigator.connection.rtt
        ? 0
        : navigator.connection.rtt;
    },
    abp: function () {
      var e,
        n =
          null === (e = document) || void 0 === e ? void 0 : e.documentElement;
      if (void 0 === n) throw new Error("documentElement not defined");
      if ("function" != typeof n.getAttributeNames)
        throw new Error("documentElement getAttributeNames not a function");
      return n.getAttributeNames();
    },
    acn: function () {
      return (function (e, n) {
        for (
          var t = [], r = Object.getOwnPropertyNames(e), o = 0;
          o < r.length;
          o++
        ) {
          var i = r[o],
            a = Ye(i);
          n.has(a) && t.push({ [On]: o, [Pn]: i });
        }
        return { [Sn]: r.length, [En]: t };
      })(Navigator.prototype, jn);
    },
    acr: function () {
      var e = oe && oe.document && oe.document.body ? oe : window,
        n = Array.from({ length: 80 }, function (e, n) {
          return String.fromCodePoint(128512 + n);
        }).join(""),
        t = e.document.createElement("span");
      return (
        (t.style.whiteSpace = "nowrap"),
        (t.innerHTML = n),
        e.document.body.appendChild(t),
        I(t, e)
      );
    },
    acg: function () {
      try {
        // eslint-disable-next-line no-undef
        return objectToInspect;
      } catch (e) {
        return !1;
      }
    },
    ach: function () {
      var e = document.createElement("div");
      (e.style.border = ".5px dotted transparent"),
        document.body.appendChild(e);
      var n = e.offsetHeight;
      return document.body.removeChild(e), n;
    },
    aci: function () {
      return navigator.onLine;
    },
    ai: function () {
      try {
        return !!window.localStorage;
      } catch (e) {
        return !0;
      }
    },
    i: function () {
      return navigator.cpuClass ? navigator.cpuClass : null;
    },
    q: function () {
      var e = null;
      return (
        P("forced-colors", "active") && (e = !0),
        P("forced-colors", "none") && (e = !1),
        e
      );
    },
    h: function () {
      try {
        document.cookie = "cokkieTesting=1; SameSite=Strict;";
        var e = -1 !== document.cookie.indexOf("cokkieTesting=");
        return (
          (document.cookie =
            "cokkieTesting=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT"),
          e
        );
      } catch (e) {
        return !1;
      }
    },
    az: function () {
      try {
        return !!window.sessionStorage;
      } catch (e) {
        return !0;
      }
    },
    w: function () {
      if (_) return null;
      try {
        return !!window.indexedDB;
      } catch (e) {
        return !0;
      }
    },
    an: function () {
      if (!P("min-monochrome", 0).matches) return null;
      for (var e = 0; e <= 100; ++e)
        if (P("max-monochrome", e).matches) return e;
      return 999;
    },
    g: function () {
      return P("prefers-contrast", "no-preference")
        ? 0
        : P("prefers-contrast", "high") || P("prefers-contrast", "more")
        ? 1
        : P("prefers-contrast", "low") || P("prefers-contrast", "less")
        ? -1
        : P("prefers-contrast", "forced")
        ? 10
        : null;
    },
    am: function () {
      var e = null;
      return (
        P("prefers-reduced-motion", "reduce") && (e = !0),
        P("prefers-reduced-motion", "no-preference") && (e = !1),
        e
      );
    },
    aal: function () {
      var e = window.WebAssembly;
      if (e && e.validate) {
        for (
          var n = [
              0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10,
            ],
            t = 0,
            r = [
              [
                9, 1, 7, 0, 65, 0, 253, 15, 26, 11, 0, 10, 4, 110, 97, 109, 101,
                2, 3, 1, 0, 0,
              ],
              [
                240, 67, 0, 0, 0, 12, 1, 10, 0, 252, 2, 3, 1, 1, 0, 0, 110, 26,
                11, 161, 10,
              ],
              [
                6, 1, 4, 0, 18, 0, 11, 0, 10, 4, 110, 97, 109, 101, 2, 3, 1, 0,
                0,
              ],
              [
                8, 1, 6, 0, 65, 0, 192, 26, 11, 0, 10, 4, 110, 97, 109, 101, 2,
                3, 1, 0, 0,
              ],
              [
                7, 1, 5, 0, 208, 112, 26, 11, 0, 10, 4, 110, 97, 109, 101, 2, 3,
                1, 0, 0,
              ],
            ],
            o = 0;
          o < r.length;
          o += 1
        ) {
          var i = r[o];
          (t <<= 1),
            (t |= e.validate(Uint8Array.of.apply(Uint8Array, p(qe(n, i))))
              ? 1
              : 0);
        }
        return t;
      }
      return null;
    },
    b: function () {
      var e = document.createElement("a").attributionsourceid;
      return null == e ? null : e;
    },
    o: function () {
      return eval.toString().length;
    },
    ack: function () {
      for (
        var e = [], n = Object.getOwnPropertyNames(window), t = 0;
        t < n.length;
        t++
      ) {
        var r = n[t],
          o = Ye(r);
        if ((tn.has(o) && e.push(r), o === nn)) {
          var i = n[t + 1] || "";
          e.push(i);
        }
      }
      return e;
    },
    aae: function () {
      var e,
        n,
        t =
          null === (e = window.Intl) || void 0 === e
            ? void 0
            : e.DateTimeFormat,
        r = null;
      if (t) {
        var o = new t().resolvedOptions().timeZone;
        o && (r = o);
      } else {
        var i =
          ((n = new Date().getFullYear()),
          -Math.max(
            O(new Date(n, 0, 1).getTimezoneOffset()),
            O(new Date(n, 6, 1).getTimezoneOffset())
          ));
        r = "UTC".concat(i >= 0 ? "+" : "").concat(i);
      }
      return r;
    },
    aaf: function () {
      var e,
        n = 0;
      void 0 !== navigator.maxTouchPoints
        ? (n = j(navigator.maxTouchPoints))
        : void 0 !== navigator.msMaxTouchPoints &&
          (n = navigator.msMaxTouchPoints);
      try {
        document.createEvent("TouchEvent"), (e = !0);
      } catch {
        e = !1;
      }
      return { a: n, b: e, c: "ontouchstart" in window };
    },
    k: function () {
      return window.devicePixelRatio || null;
    },
    u: function () {
      var e = null;
      return (
        P("dynamic-range", "high") && (e = !0),
        P("dynamic-range", "standard") && (e = !1),
        e
      );
    },
    aai: function () {
      var e = navigator,
        n = [],
        t =
          e.language || e.userLanguage || e.browserLanguage || e.systemLanguage;
      if ((void 0 !== t && n.push(t), Array.isArray(e.languages)))
        (D && Ge) || n.push.apply(n, p(e.languages));
      else if ("string" == typeof e.languages) {
        var r = e.languages;
        r && n.push(r.split(","));
      }
      return n;
    },
    abk: function () {
      return navigator.userAgent;
    },
    abf: function () {
      return P("any-pointer", "none")
        ? 0
        : P("any-pointer", "fine")
        ? 1
        : P("any-pointer", "coarse")
        ? 2
        : null;
    },
    ao: function () {
      return !!window.openDatabase;
    },
    at: function () {
      var e = null;
      return (
        P("prefers-color-scheme", "dark") && (e = "dark"),
        P("prefers-color-scheme", "light") && (e = "light"),
        e
      );
    },
    aam: function () {
      try {
        var { ApplePaySession: e } = window;
        return "function" != typeof (null == e ? void 0 : e.canMakePayments)
          ? -1
          : (function () {
              for (var e = window; ; ) {
                var n = e.parent;
                if (!n || n === e) return !1;
                try {
                  if (n.location.origin !== e.location.origin) return !0;
                } catch (e) {
                  if (e instanceof Error && "SecurityError" === e.name)
                    return !0;
                  throw e;
                }
                e = n;
              }
            })()
          ? -3
          : e.canMakePayments()
          ? 1
          : 0;
      } catch (e) {
        if (
          e instanceof Error &&
          "InvalidAccessError" === e.name &&
          /\bfrom\b.*\binsecure\b/i.test(e.message)
        )
          return -2;
        throw new Error(e);
      }
    },
    aap: function () {
      return (
        !!P("prefers-reduced-transparency", "reduce") ||
        (!P("prefers-reduced-transparency", "no-preference") && null)
      );
    },
    aax: function () {
      return {
        a: rn(function () {
          return new Intl.DateTimeFormat(void 0, {
            month: "long",
            timeZoneName: "long",
          }).format(9636444e5);
        }),
        b: rn(function () {
          return new Intl.DisplayNames(void 0, { type: "language" }).of(
            "en-US"
          );
        }),
        c: rn(function () {
          return new Intl.ListFormat(void 0, {
            style: "long",
            type: "disjunction",
          }).format(["0", "1"]);
        }),
        d: rn(function () {
          return new Intl.NumberFormat(void 0, {
            notation: "compact",
            compactDisplay: "long",
          }).format(21e6);
        }),
        e: rn(function () {
          return new Intl.PluralRules().select(1);
        }),
        f: rn(function () {
          return new Intl.RelativeTimeFormat(void 0, {
            localeMatcher: "best fit",
            numeric: "auto",
            style: "long",
          }).format(1, "year");
        }),
        g:
          "" +
          ((e = Intl),
          (n = [
            "Collator",
            "DateTimeFormat",
            "DisplayNames",
            "ListFormat",
            "NumberFormat",
            "PluralRules",
            "RelativeTimeFormat",
          ].reduce(function (n, t) {
            try {
              var r = new e[t]();
              if (!r) return n;
              var { locale: o } = r.resolvedOptions() || {};
              return [].concat(p(n), [o]);
            } catch (e) {
              return n;
            }
          }, [])),
          p(new Set(n))),
      };
      var e, n;
    },
    aba: function () {
      var e = oe && oe.document && oe.document.body ? oe : window,
        n = oe && oe.document && oe.document.body ? oe.document : document;
      if (Z) {
        var t = n.createElement("input");
        (t.type = "radio"), n.body.appendChild(t);
        var r = e.getComputedStyle(t).getPropertyValue("font-family");
        return n.body.removeChild(t), r;
      }
      return null;
    },
    aaz: function () {
      var e = oe && oe.document && oe.document.body ? oe.document : document,
        n = e.createElement("div");
      (n.style.cssText =
        "\n    width: 100px;\n    height: 100px;\n    overflow: scroll;\n    visibility: hidden;\n  "),
        e.body.appendChild(n);
      var t = n.offsetWidth === n.clientWidth;
      return e.body.removeChild(n), t;
    },
    aay: function () {
      try {
        return new FontFace("font", "local('Arial')").load(), !0;
      } catch (e) {
        return !1;
      }
    },
    abd: function () {
      var e = document.createElement("a");
      return (
        (e.style.width =
          "calc( 1px * ( sin( 66911823500 * ( 36781 / -0.55 * cos( -30780.497322536891 ) ) ) ) )"),
        e.style.width
      );
    },
    aau: function () {
      return new Promise(function (e, n) {
        try {
          var t = function (e) {
            return navigator.permissions
              .query({ name: e })
              .then(function (n) {
                return { name: e, state: n.state };
              })
              .catch(function (n) {
                return { name: e, state: "unknown" };
              });
          };
          "permissions" in navigator || e(null),
            e(
              Promise.all([
                t("accelerometer"),
                t("ambient-light-sensor"),
                t("background-fetch"),
                t("background-sync"),
                t("bluetooth"),
                t("camera"),
                t("clipboard"),
                t("device-info"),
                t("display-capture"),
                t("gamepad"),
                t("geolocation"),
                t("gyroscope"),
                t("magnetometer"),
                t("microphone"),
                t("midi"),
                t("nfc"),
                t("notifications"),
                t("persistent-storage"),
                t("push"),
                t("screen-wake-lock"),
                t("speaker"),
                t("speaker-selection"),
              ])
                .then(function (e) {
                  return e.reduce(function (e, n) {
                    var { state: t, name: r } = n || {},
                      o = on[t] || t;
                    return e[o] ? (e[o].push(r), e) : ((e[o] = [r]), e);
                  }, {});
                })
                .catch(function (e) {
                  return (
                    (null == e ? void 0 : e.message) || "Permissions error"
                  );
                })
            );
        } catch (e) {
          n(e);
        }
      });
    },
    n: function () {
      var e = navigator.doNotTrack || navigator.msDoNotTrack;
      return null != e ? [!0, "1", "yes", 1].indexOf(e) > -1 : null;
    },
    al: function () {
      return new Promise(
        (function () {
          var e = n(function* (e, n) {
            navigator.requestMediaKeySystemAccess || e(null);
            try {
              var t,
                r = yield navigator.requestMediaKeySystemAccess(
                  "org.w3.clearkey",
                  [
                    {
                      initDataTypes: ["keyids", "webm"],
                      audioCapabilities: ["opus", "vorbis"].map(function (e) {
                        return {
                          contentType: 'audio/webm; codecs="'.concat(e, '"'),
                        };
                      }),
                      videoCapabilities: ["vp9", "vp8"].map(function (e) {
                        return {
                          contentType: 'video/webm; codecs="'.concat(e, '"'),
                        };
                      }),
                    },
                  ]
                ),
                o = (yield r.createMediaKeys()).createSession();
              o.sessionId && e(o.sessionId);
              var i = yield new Promise(function (e, n) {
                (o.onmessage = e),
                  o.generateRequest("webm", new Uint8Array([1, 1, 1, 1]));
              });
              e(
                null == i || null === (t = i.currentTarget) || void 0 === t
                  ? void 0
                  : t.sessionId
              );
            } catch (t) {
              "NotSupportedError" === t.name && e("notSupported"), n(t);
            }
          });
          return function (n, t) {
            return e.apply(this, arguments);
          };
        })()
      );
    },
    acl: function () {
      var e = Xe(navigator, 2698072953);
      if (!e) return null;
      var n = (function (e) {
        var n = Xe(Object, 1110892003)(e, "length");
        if (n && Xe(n, 2813370411)) return !0;
        for (var t = 0; t < e.length; t++) {
          var r = Xe(Object, 1110892003)(e, t);
          if (r && (Xe(r, 2813370411) || Xe(r, 1651707638))) return !0;
        }
        return !1;
      })(e);
      return n;
    },
    abl: function () {
      return navigator.appVersion || null;
    },
    acb: function () {
      return "undefined" == typeof CSS
        ? null
        : CSS.supports("backdrop-filter", "blur(2px)");
    },
    abs: function () {
      return !Function.prototype.bind || Function.prototype.bind.toString();
    },
    abq: function () {
      if (void 0 === window.external) return "undefined";
      var e = window.external;
      return "function" != typeof e.toString ? "NOT_FUNCTION" : e.toString();
    },
    acc: function () {
      if ("function" != typeof window.matchMedia)
        throw new Error("matchMedia not a function");
      var e = window.matchMedia(
        "(-webkit-min-device-pixel-ratio: 2), (min-device-pixel-ratio: 2), (min-resolution: 192dpi)"
      );
      if (void 0 === e.matches)
        throw new Error("HighPixelDensityCheck matchMedia undefined");
      return e.matches;
    },
    abj: function () {
      return Boolean(window.isSecureContext);
    },
    abr: function () {
      if (void 0 === navigator.mimeTypes) return 0;
      var e = navigator.mimeTypes;
      if (Object.getPrototypeOf(e) !== MimeTypeArray.prototype) return !1;
      for (var n = 0; n < e.length; n++)
        if (Object.getPrototypeOf(e[n]) !== MimeType.prototype) return !1;
      return !0;
    },
    aca: function () {
      return navigator.mimeTypes
        ? void 0 === navigator.mimeTypes.length
          ? null
          : navigator.mimeTypes.length
        : null;
    },
    ace: function () {
      for (
        var e = navigator,
          n = ["webkitPersistentStorage", "connectionSpeed", "xr", "hid"],
          t = [],
          r = Object.getOwnPropertyNames(Object.getPrototypeOf(e)),
          o = 0;
        o < r.length;
        o++
      ) {
        var i = r[o];
        if (!n.includes(i)) {
          var a = e[i];
          "function" == typeof a && void 0 !== a.name && t.push(a.name);
        }
      }
      return t;
    },
    abe: function () {
      return new URL("C:/").protocol;
    },
    abw: function () {
      if (void 0 === navigator.plugins) return null;
      for (
        var e = navigator.plugins,
          n = Object.getPrototypeOf(e) === PluginArray.prototype,
          t = 0;
        t < e.length;
        t++
      )
        n && (n = Object.getPrototypeOf(e[t]) === Plugin.prototype);
      return n;
    },
    abt: function () {
      var e = window.process;
      if (void 0 === e) throw new Error("ProcessPresence not present");
      if (e && "object" != typeof e)
        throw new Error("ProcessPresence not object");
      return e;
    },
    abo: function () {
      var e = navigator.productSub;
      return void 0 === e ? "navigator.productSub is undefined" : e;
    },
    acj: function () {
      var e = {};
      for (var [n, t] of wn)
        for (var r of t) {
          var o,
            i = Object.getOwnPropertyDescriptor(window[n], r),
            a =
              null == i || null === (o = i.get) || void 0 === o
                ? void 0
                : o.toString();
          void 0 !== a && (e["".concat(n, ".").concat(r)] = a);
        }
      return e;
    },
    acm: function () {
      var e = Xe(new window.Event(""), 3966979758);
      return "boolean" != typeof e ? null : { a: e };
    },
    acd: function () {
      if ("function" != typeof window.SharedArrayBuffer) return -2;
      var e = new window.SharedArrayBuffer(1);
      return void 0 === e.byteLength ? -1 : e.byteLength;
    },
    abx: function () {
      return new Promise(function (e) {
        try {
          throw "a";
        } catch (n) {
          try {
            n.toSource(), e(!0);
          } catch (n) {
            e(!1);
          }
        }
      });
    },
    abz: function () {
      return void 0 === window.close ? null : window.close.toString();
    },
    ap: function () {
      return navigator.oscpu ? navigator.oscpu : null;
    },
    aaa: function () {
      return [typeof SourceBuffer, typeof SourceBufferList];
    },
    aj: function () {
      var e = Math;
      try {
        var n = e.acos || ft,
          t = e.acosh || ft,
          r = e.asin || ft,
          o = e.asinh || ft,
          i = e.atanh || ft,
          a = e.atan || ft,
          c = e.sin || ft,
          u = e.sinh || ft,
          l = e.cos || ft,
          s = e.cosh || ft,
          d = e.tan || ft,
          f = e.tanh || ft,
          m = e.exp || ft,
          v = e.expm1 || ft,
          p = e.log1p || ft,
          h = {
            ACOS: n(0.12312423423423424),
            ACOSH: t(1e308),
            ACOSHPF: (function (n) {
              return e.log(n + e.sqrt(n * n - 1));
            })(1e154),
            ASIN: r(0.12312423423423424),
            ASINH: o(1),
            ASINHPF: e.log(1 + e.sqrt(2)),
            ATANH: i(0.5),
            ATANHPF: e.log(3) / 2,
            ATAN: a(0.5),
            SIN: c(-1e300),
            SINH: u(1),
            SINHPF: e.exp(1) - 1 / e.exp(1) / 2,
            COS: l(10.000000000123),
            COSH: s(1),
            COSHPF: (e.exp(1) + 1 / e.exp(1)) / 2,
            TAN: d(-1e300),
            TANH: f(1),
            TANHPF: (e.exp(2) - 1) / (e.exp(2) + 1),
            EXP: m(1),
            EXPM1: v(1),
            EXPM1PF: e.exp(1) - 1,
            LOG1P: p(10),
            LOG1P_PF: e.log(11),
            POW_PI: e.pow(e.PI, -100),
          };
        return ee(h);
      } catch (e) {
        return null;
      }
    },
    aao: function () {
      var { pdfViewerEnabled: e } = navigator;
      return null !== e || void 0 !== e ? e : null;
    },
    abn: function () {
      try {
        null[0]();
      } catch (e) {
        if (e instanceof Error && null != e.stack) return e.stack.toString();
      }
      return "errorTrace signal unexpected behaviour";
    },
    m: function () {
      return new Promise(function (e, n) {
        try {
          var t,
            r = {
              abpIndo: [
                "#Iklan-Melayang",
                "#Kolom-Iklan-728",
                "#SidebarIklan-wrapper",
                '[title="ALIENBOLA" i]',
                (a = atob)("I0JveC1CYW5uZXItYWRz"),
              ],
              abpvn: [
                ".quangcao",
                "#mobileCatfish",
                a("LmNsb3NlLWFkcw=="),
                '[id^="bn_bottom_fixed_"]',
                "#pmadv",
              ],
              adBlockFinland: [
                ".mainostila",
                a("LnNwb25zb3JpdA=="),
                ".ylamainos",
                a("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
                a("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd"),
              ],
              adBlockPersian: [
                "#navbar_notice_50",
                ".kadr",
                'TABLE[width="140px"]',
                "#divAgahi",
                a("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd"),
              ],
              adBlockWarningRemoval: [
                "#adblock-honeypot",
                ".adblocker-root",
                ".wp_adblock_detect",
                a("LmhlYWRlci1ibG9ja2VkLWFk"),
                a("I2FkX2Jsb2NrZXI="),
              ],
              adGuardAnnoyances: [
                ".hs-sosyal",
                "#cookieconsentdiv",
                'div[class^="app_gdpr"]',
                ".as-oil",
                '[data-cypress="soft-push-notification-modal"]',
              ],
              adGuardBase: [
                ".BetterJsPopOverlay",
                a("I2FkXzMwMFgyNTA="),
                a("I2Jhbm5lcmZsb2F0MjI="),
                a("I2NhbXBhaWduLWJhbm5lcg=="),
                a("I0FkLUNvbnRlbnQ="),
              ],
              adGuardChinese: [
                a("LlppX2FkX2FfSA=="),
                a("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
                "#widget-quan",
                a("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
                a("YVtocmVmKj0iLjE5NTZobC5jb20vIl0="),
              ],
              adGuardFrench: [
                "#pavePub",
                a("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
                ".mobile_adhesion",
                ".widgetadv",
                a("LmFkc19iYW4="),
              ],
              adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
              adGuardJapanese: [
                "#kauli_yad_1",
                a("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
                a("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
                a("LmFkZ29vZ2xl"),
                a("Ll9faXNib29zdFJldHVybkFk"),
              ],
              adGuardMobile: [
                a("YW1wLWF1dG8tYWRz"),
                a("LmFtcF9hZA=="),
                'amp-embed[type="24smi"]',
                "#mgid_iframe1",
                a("I2FkX2ludmlld19hcmVh"),
              ],
              adGuardRussian: [
                a("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
                a("LnJlY2xhbWE="),
                'div[id^="smi2adblock"]',
                a("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
                "#psyduckpockeball",
              ],
              adGuardSocial: [
                a(
                  "YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="
                ),
                a("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
                ".etsy-tweet",
                "#inlineShare",
                ".popup-social",
              ],
              adGuardSpanishPortuguese: [
                "#barraPublicidade",
                "#Publicidade",
                "#publiEspecial",
                "#queTooltip",
                ".cnt-publi",
              ],
              adGuardTrackingProtection: [
                "#qoo-counter",
                a("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
                a(
                  "YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="
                ),
                a("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
                "#top100counter",
              ],
              adGuardTurkish: [
                "#backkapat",
                a("I3Jla2xhbWk="),
                a("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
                a("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
                a("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ=="),
              ],
              bulgarian: [
                a("dGQjZnJlZW5ldF90YWJsZV9hZHM="),
                "#ea_intext_div",
                ".lapni-pop-over",
                "#xenium_hot_offers",
              ],
              easyList: [
                ".yb-floorad",
                a("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
                a("LnRyYWZmaWNqdW5reS1hZA=="),
                ".textad_headline",
                a("LnNwb25zb3JlZC10ZXh0LWxpbmtz"),
              ],
              easyListChina: [
                a("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
                a("LmZyb250cGFnZUFkdk0="),
                "#taotaole",
                "#aafoot.top_box",
                ".cfa_popup",
              ],
              easyListCookie: [
                ".ezmob-footer",
                ".cc-CookieWarning",
                "[data-cookie-number]",
                a("LmF3LWNvb2tpZS1iYW5uZXI="),
                ".sygnal24-gdpr-modal-wrap",
              ],
              easyListCzechSlovak: [
                "#onlajny-stickers",
                a("I3Jla2xhbW5pLWJveA=="),
                a("LnJla2xhbWEtbWVnYWJvYXJk"),
                ".sklik",
                a("W2lkXj0ic2tsaWtSZWtsYW1hIl0="),
              ],
              easyListDutch: [
                a("I2FkdmVydGVudGll"),
                a("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
                ".adstekst",
                a("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
                "#semilo-lrectangle",
              ],
              easyListGermany: [
                "#SSpotIMPopSlider",
                a("LnNwb25zb3JsaW5rZ3J1ZW4="),
                a("I3dlcmJ1bmdza3k="),
                a("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
                a("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0="),
              ],
              easyListItaly: [
                a("LmJveF9hZHZfYW5udW5jaQ=="),
                ".sb-box-pubbliredazionale",
                a("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
                a("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
                a(
                  "YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ=="
                ),
              ],
              easyListLithuania: [
                a("LnJla2xhbW9zX3RhcnBhcw=="),
                a("LnJla2xhbW9zX251b3JvZG9z"),
                a("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
                a("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
                a("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd"),
              ],
              estonian: [a("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
              fanboyAnnoyances: [
                "#ac-lre-player",
                ".navigate-to-top",
                "#subscribe_popup",
                ".newsletter_holder",
                "#back-top",
              ],
              fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
              fanboyEnhancedTrackers: [
                ".open.pushModal",
                "#issuem-leaky-paywall-articles-zero-remaining-nag",
                "#sovrn_container",
                'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
                ".BlockNag__Card",
              ],
              fanboySocial: [
                "#FollowUs",
                "#meteored_share",
                "#social_follow",
                ".article-sharer",
                ".community__social-desc",
              ],
              frellwitSwedish: [
                a("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
                a("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
                "article.category-samarbete",
                a("ZGl2LmhvbGlkQWRz"),
                "ul.adsmodern",
              ],
              greekAdBlock: [
                a("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
                a("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
                a(
                  "QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"
                ),
                "DIV.agores300",
                "TABLE.advright",
              ],
              hungarian: [
                "#cemp_doboz",
                ".optimonk-iframe-container",
                a("LmFkX19tYWlu"),
                a("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
                "#hirdetesek_box",
              ],
              iDontCareAboutCookies: [
                '.alert-info[data-block-track*="CookieNotice"]',
                ".ModuleTemplateCookieIndicator",
                ".o--cookies--container",
                "#cookies-policy-sticky",
                "#stickyCookieBar",
              ],
              icelandicAbp: [
                a(
                  "QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ=="
                ),
              ],
              latvian: [
                a(
                  "YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="
                ),
                a(
                  "YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ=="
                ),
              ],
              listKr: [
                a("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
                a("I2xpdmVyZUFkV3JhcHBlcg=="),
                a("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
                a("aW5zLmZhc3R2aWV3LWFk"),
                ".revenue_unit_item.dable",
              ],
              listeAr: [
                a("LmdlbWluaUxCMUFk"),
                ".right-and-left-sponsers",
                a("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
                a("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
                a("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd"),
              ],
              listeFr: [
                a("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
                a("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
                a("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
                ".site-pub-interstitiel",
                'div[id^="crt-"][data-criteo-id]',
              ],
              officialPolish: [
                "#ceneo-placeholder-ceneo-12",
                a("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
                a(
                  "YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="
                ),
                a(
                  "YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="
                ),
                a("ZGl2I3NrYXBpZWNfYWQ="),
              ],
              ro: [
                a("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
                a(
                  "YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"
                ),
                a(
                  "YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="
                ),
                a("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
                'a[href^="/url/"]',
              ],
              ruAd: [
                a("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
                a("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
                a("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
                "#pgeldiz",
                ".yandex-rtb-block",
              ],
              thaiAds: [
                "a[href*=macau-uta-popup]",
                a("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
                a("LmFkczMwMHM="),
                ".bumq",
                ".img-kosana",
              ],
              webAnnoyancesUltralist: [
                "#mod-social-share-2",
                "#social-tools",
                a("LmN0cGwtZnVsbGJhbm5lcg=="),
                ".zergnet-recommend",
                ".yt.btn-link.btn-md.btn",
              ],
            },
            o = Object.keys(r),
            i = (t = []).concat.apply(
              t,
              p(
                o.map(function (e) {
                  return r[e];
                })
              )
            );
          vt(i).then(function (n) {
            var t = o.filter(function (e) {
              var t = r[e];
              return (
                R(
                  t.map(function (e) {
                    return n[e];
                  })
                ) >
                0.6 * t.length
              );
            });
            t.sort(), e(t);
          });
        } catch (e) {
          n(e);
        }
        var a;
      });
    },
    aaw: function () {
      try {
        var e = new Float32Array(1),
          n = new Uint8Array(e.buffer);
        return (e[0] = 1 / 0), (e[0] = e[0] - e[0]), n[3];
      } catch (e) {
        return -3;
      }
    },
    adh: function () {
      return (function (e) {
        var n = Object.getOwnPropertyDescriptor(
          Object.getPrototypeOf(e),
          "hardwareConcurrency"
        );
        if (!n || !n.get) return null;
        var t = window.Function,
          r = window.Object,
          o = function () {
            try {
              (window.Function = t), (window.Object = r);
            } catch {}
          },
          i = !1;
        try {
          i = delete window.Function && delete window.Object;
        } catch {
          i = !1;
        }
        if (!i) return o(), null;
        try {
          return n.get.toString(), !1;
        } catch {
          return !0;
        } finally {
          o();
        }
      })(navigator);
    },
  },
  ht = {
    aab: function () {
      var e,
        n,
        t = window.speechSynthesis;
      if (!t || !t.getVoices || "function" != typeof t.getVoices)
        return Promise.resolve(null);
      if (!t.addEventListener || (Z && G)) {
        var r = t.getVoices(),
          o = (r || [])
            .map(function (e) {
              return e.name;
            })
            .map(function (e) {
              return e.slice(0, 6);
            })
            .map(function (e) {
              return Ye(e);
            })
            .some(function (e) {
              return 1655763047 === e;
            });
        return (
          (e = Ln(r).join(",")),
          ee(e).then(function (e) {
            return Promise.resolve({ a: o, z: e });
          })
        );
      }
      var i = new Promise(function (e, r) {
        var o,
          i = function () {
            t.getVoices().length
              ? (null == o || o(), (o = le(e, 50)))
              : o || (o = ue(e, 600));
          };
        (n = function () {
          try {
            i();
          } catch (e) {
            r(e);
          }
        }),
          i(),
          t.addEventListener("voiceschanged", n);
      });
      return new Promise(function (e, r) {
        i.then(
          function (r) {
            var o = t.getVoices();
            n && t.removeEventListener("voiceschanged", n);
            var i = (o || [])
                .map(function (e) {
                  return e.name;
                })
                .map(function (e) {
                  return e.slice(0, 6);
                })
                .map(function (e) {
                  return Ye(e);
                })
                .some(function (e) {
                  return 1655763047 === e;
                }),
              a = o.length ? Ln(o).join(",") : "";
            return ee(a).then(function (n) {
              return e({ a: i, z: n });
            });
          },
          function (e) {
            r(e);
          }
        ).catch(function (e) {
          r(e);
        });
      });
    },
    aag: function () {
      var { userAgentData: e } = navigator;
      return e && "object" == typeof e
        ? new Promise(
            (function () {
              var t = n(function* (n, t) {
                var r,
                  o = {};
                if ("function" == typeof e.getHighEntropyValues) {
                  var i = [];
                  xn.forEach(function (n) {
                    i.push(e.getHighEntropyValues([n]));
                  }),
                    (r = yield Promise.all(i)),
                    xn.forEach(function (e, n) {
                      var t = r[n];
                      t &&
                        "object" == typeof t &&
                        t[e] &&
                        (o[In[e]] =
                          "string" == typeof t[e]
                            ? t[e]
                            : JSON.stringify(t[e]));
                    });
                }
                n({
                  a: e.brands.map(function (e) {
                    return { a: e.brand, b: e.version };
                  }),
                  b: e.mobile,
                  c:
                    null !== e.platform && void 0 !== e.platform
                      ? e.platform
                      : null,
                  d: o,
                });
              });
              return function (e, n) {
                return t.apply(this, arguments);
              };
            })()
          )
        : Promise.resolve(null);
    },
    ax: function () {
      var e,
        n = window.RTCPeerConnection || window.webkitRTCPeerConnection,
        t = [];
      if (n) {
        try {
          e = new window.RTCPeerConnection({
            iceServers: [
              "stun2.l.google.com:19302",
              "stun.l.google.com:19302",
            ].map(function (e) {
              return { urls: "stun:".concat(e) };
            }),
          });
        } catch (e) {
          return Promise.reject(e);
        }
        var r = new Promise(function (n, r) {
          var o,
            i = !1;
          (e.onicecandidate = function (e) {
            var r = e.candidate;
            r || n(0);
            var { candidate: o } = r || {};
            o &&
              (t.push(o),
              !i && / typ [sp]rflx /.test(o) && ((i = !0), ue(n, 10, 0)));
          }),
            (e.onicegatheringstatechange = function () {
              "complete" === e.iceGatheringState && n(0);
            });
          try {
            null != (o = e.createDataChannel) && o.call(e, "test");
          } catch (e) {
            "NotSupportedError" === e.name ? n(null) : r(e);
          }
          var a = (function (e, n) {
            try {
              return e.createOffer(n);
            } catch (t) {
              return /\bcreateOffer\b.*(\bcallback\b.*\bnot a function\b|\barguments required\b.*\bpresent\b)/i.test(
                t.message
              )
                ? new Promise(function (t, r) {
                    e.createOffer(t, r, n);
                  })
                : r(new Error("create offer rejected"));
            }
          })(e, V ? { offerToReceiveAudio: !0 } : void 0);
          void 0 === a
            ? n(t)
            : a.then(function (n) {
                e.setLocalDescription(n);
              }, r);
        });
        return Te(ce(2e3, -9), r)
          .then(function (e) {
            if (-9 === e) throw new Error("timed out");
            if (null === e) throw new Error("null response");
            return t;
          })
          .catch(function (e) {
            return t;
          });
      }
    },
    c: function () {
      if ((M && Ze && We) || (D && B() && Fe)) return -4;
      var e = window.OfflineAudioContext || window.webkitOfflineAudioContext;
      if (!e) return -2;
      if (M && !F && !He) return -1;
      var n = new e(1, 5e3, 44100),
        t = n.createOscillator();
      (t.type = "triangle"), (t.frequency.value = 1e4);
      var r = n.createDynamicsCompressor();
      (r.threshold.value = -50),
        (r.knee.value = 40),
        (r.ratio.value = 12),
        (r.attack.value = 0),
        (r.release.value = 0.25),
        t.connect(r),
        r.connect(n.destination),
        t.start(0);
      var [o, i] = (function (e) {
          var n = function () {};
          return [
            new Promise(function (t, r) {
              var o = !1,
                i = 0,
                a = 0;
              e.oncomplete = function (e) {
                return t(e.renderedBuffer);
              };
              var c = function () {
                  setTimeout(function () {
                    return r(_n(Tn));
                  }, Math.min(200, a + 5e3 - Date.now()));
                },
                u = function () {
                  try {
                    switch ((e.startRendering(), e.state)) {
                      case "running":
                        (a = Date.now()), o && c();
                        break;
                      case "suspended":
                        document.hidden || (i += 1),
                          o && i >= 3 ? r(_n(Nn)) : setTimeout(u, 200);
                    }
                  } catch (e) {
                    r(e);
                  }
                };
              u(),
                (n = function () {
                  o || ((o = !0), a > 0 && c());
                });
            }),
            n,
          ];
        })(n),
        a = q(
          o.then(
            function (e) {
              return (function (e) {
                for (var n = 0, t = 0; t < e.length; t += 1)
                  n += Math.abs(e[t]);
                return n;
              })(e.getChannelData(0).subarray(4500));
            },
            function (e) {
              return e.name === Tn || e.name === Nn ? -3 : null;
            }
          )
        );
      return (
        a.catch(function (e) {}),
        new Promise(function (e) {
          i(),
            a.then(function (n) {
              null == n && e(null), e(n);
            });
        })
      );
    },
    aco: function () {
      if (!M && !Z) return null;
      var e = window.indexedDB;
      if (!e) return null;
      var n = "".concat(Ne(16));
      return new Promise(function (t, r) {
        try {
          var o = Xe(e, 2758837156)(n, 1);
          (o.onerror = function () {
            t(null);
          }),
            (o.onupgradeneeded = function (r) {
              var o = Xe(r, 1181691900),
                i = Xe(o, 325763347);
              try {
                var a = Xe(i, 138212912)("-", { autoIncrement: !0 });
                Xe(a, 2928708052)(new window.Blob()), t("");
              } catch (e) {
                if (e instanceof Error) {
                  var c = Xe(e, 3065852031);
                  t(c);
                }
                t(null);
              } finally {
                var u = Xe(i, 318865860),
                  l = Xe(e, 3885781331);
                u && u(), l && l(n);
              }
              t(null);
            });
        } catch (e) {
          M || t((null == e ? void 0 : e.message) || "error"),
            e instanceof Error &&
              "SecurityError" === e.name &&
              t("SecurityError"),
            r(e);
        }
      });
    },
  },
  yt = {
    abb: function () {
      return new Promise(function (e, n) {
        try {
          var t =
              oe && oe.document && oe.document.body ? oe.document : document,
            r = "font-fingerprint",
            o = t.createElement("div");
          o.setAttribute("id", r), t.body.appendChild(o);
          var { emojiSet: i, pixelSizeSystemSum: a } =
            (function (e) {
              var { doc: n, id: t, emojis: r } = e;
              try {
                ze(
                  n.getElementById(t),
                  Je(
                    Ue ||
                      (Ue = an([
                        '\n      <div id="pixel-emoji-container">\n      <style>\n        .pixel-emoji {\n          font-family: ',
                        ";\n          font-size: 200px !important;\n          height: auto;\n          position: absolute !important;\n          transform: scale(1.000999);\n        }\n        </style>\n        ",
                        "\n      </div>\n    ",
                      ])),
                    Ke,
                    r
                      .map(function (e) {
                        return '<div class="pixel-emoji">'.concat(e, "</div>");
                      })
                      .join("")
                  )
                );
                var o = new Set(),
                  i = p(n.getElementsByClassName("pixel-emoji")).reduce(
                    function (e, n, t) {
                      var i = getComputedStyle(n),
                        a = r[t],
                        { height: c, width: u } = (function (e) {
                          return { width: e.inlineSize, height: e.blockSize };
                        })(i),
                        l = "".concat(u, ",").concat(c);
                      return o.has(l) || (o.add(l), e.add(a)), e;
                    },
                    new Set()
                  ),
                  a =
                    1e-5 *
                    p(o)
                      .map(function (e) {
                        return e
                          .split(",")
                          .map(function (e) {
                            return +e.replace("px", "");
                          })
                          .reduce(function (e, n) {
                            return e + (+n || 0);
                          }, 0);
                      })
                      .reduce(function (e, n) {
                        return e + n;
                      }, 0);
                return (
                  n.body.removeChild(n.getElementById("pixel-emoji-container")),
                  { emojiSet: p(i), pixelSizeSystemSum: a }
                );
              } catch (e) {
                return { emojiSet: [], pixelSizeSystemSum: 0 };
              }
            })({ doc: t, id: r, emojis: Qe }) || {};
          bn(gn)
            .then(function (n) {
              var t,
                r = n,
                o =
                  (function (e) {
                    var { fonts: n, fontMap: t } = e,
                      r = {
                        11: t[11].find(function (e) {
                          return n.includes(e);
                        }),
                        10: t[10].find(function (e) {
                          return n.includes(e);
                        }),
                        8.1: t[8.1].find(function (e) {
                          return n.includes(e);
                        }),
                        8: t[8].find(function (e) {
                          return n.includes(e);
                        }),
                        7:
                          t[7].filter(function (e) {
                            return n.includes(e);
                          }).length == t[7].length,
                      },
                      o = {
                        "10,11,7,8,8.1": "11",
                        "10,7,8,8.1": "10",
                        "7,8,8.1": "8.1",
                        "11,7,8,8.1": "8.1",
                        "7,8": "8",
                        "10,7,8": "8",
                        "10,11,7,8": "8",
                        7: "7",
                        "7,8.1": "7",
                        "10,7,8.1": "7",
                        "10,11,7,8.1": "7",
                      }[
                        "" +
                          Object.keys(r)
                            .sort()
                            .filter(function (e) {
                              return !!r[e];
                            })
                      ];
                    return o ? "Windows ".concat(o) : void 0;
                  })({ fonts: (t = r), fontMap: fn }) ||
                  (function (e) {
                    var { fonts: n, fontMap: t } = e,
                      r = {
                        13: t[13].find(function (e) {
                          return n.includes(e);
                        }),
                        12: t[12].find(function (e) {
                          return n.includes(e);
                        }),
                        "10.15-11": t["10.15-11"].find(function (e) {
                          return n.includes(e);
                        }),
                        "10.13-10.14": t["10.13-10.14"].find(function (e) {
                          return n.includes(e);
                        }),
                        10.12: t[10.12].find(function (e) {
                          return n.includes(e);
                        }),
                        10.11: t[10.11].find(function (e) {
                          return n.includes(e);
                        }),
                        "10.10": t["10.10"].find(function (e) {
                          return n.includes(e);
                        }),
                        10.9:
                          t[10.9].filter(function (e) {
                            return n.includes(e);
                          }).length == t[10.9].length,
                      },
                      o = {
                        "10.10,10.11,10.12,10.13-10.14,10.15-11,10.9,12,13":
                          "Ventura",
                        "10.10,10.11,10.12,10.13-10.14,10.15-11,10.9,12":
                          "Monterey",
                        "10.10,10.11,10.12,10.13-10.14,10.15-11,10.9":
                          "10.15-11",
                        "10.10,10.11,10.12,10.13-10.14,10.9": "10.13-10.14",
                        "10.10,10.11,10.12,10.9": "Sierra",
                        "10.10,10.11,10.9": "El Capitan",
                        "10.10,10.9": "Yosemite",
                        10.9: "Mavericks",
                      }[
                        "" +
                          Object.keys(r)
                            .sort()
                            .filter(function (e) {
                              return !!r[e];
                            })
                      ];
                    return o ? "macOS ".concat(o) : void 0;
                  })({ fonts: t, fontMap: mn }),
                c = (function (e) {
                  return Object.keys(vn).reduce(function (n, t) {
                    var r = vn[t];
                    return r.filter(function (n) {
                      return e.includes(n);
                    }).length == r.length
                      ? [].concat(p(n), [t])
                      : n;
                  }, []);
                })(r);
              e({ [cn]: r, [un]: o, [ln]: c, [sn]: i, [dn]: a });
            })
            .catch(function (e) {
              n(e);
            });
        } catch (e) {
          n(e);
        }
      });
    },
    d: function () {
      return new Promise(function (e, n) {
        try {
          var t = !1,
            r = "",
            o = "",
            i = M && Ze && We,
            [a, c] = (function () {
              var e = window.document.createElement("canvas");
              return (e.width = 1), (e.height = 1), [e, e.getContext("2d")];
            })();
          if (
            !(function (e) {
              return !!(
                arguments.length > 1 &&
                void 0 !== arguments[1] &&
                arguments[1] &&
                e.toDataURL
              );
            })(a, c)
          )
            return Promise.resolve({ a: t, b: Wn, c: Wn });
          (t = Gn(c)),
            i
              ? (r = o = "skipped")
              : ([r, o] = (function (e, n) {
                  !(function (e, n) {
                    (e.width = 240),
                      (e.height = 60),
                      (n.textBaseline = "alphabetic"),
                      (n.fillStyle = "#f60"),
                      n.fillRect(100, 1, 62, 20),
                      (n.fillStyle = "#069"),
                      (n.font = '11pt "Times New Roman"');
                    var t = "Cwm fjordbank gly ".concat(
                      String.fromCharCode(55357, 56835)
                    );
                    n.fillText(t, 2, 15),
                      (n.fillStyle = "rgba(102, 204, 0, 0.2)"),
                      (n.font = "18pt Arial"),
                      n.fillText(t, 4, 45);
                  })(e, n);
                  var t = Zn(e);
                  return t !== Zn(e)
                    ? [Hn, Hn]
                    : ((function (e, n) {
                        for (var [t, r, o] of ((e.width = 122),
                        (e.height = 110),
                        (n.globalCompositeOperation = "multiply"),
                        [
                          ["#f2f", 40, 40],
                          ["#2ff", 80, 40],
                          ["#ff2", 60, 80],
                        ]))
                          (n.fillStyle = t),
                            n.beginPath(),
                            n.arc(r, o, 40, 0, 2 * Math.PI, !0),
                            n.closePath(),
                            n.fill();
                        (n.fillStyle = "#f9c"),
                          n.arc(60, 60, 60, 0, 2 * Math.PI, !0),
                          n.arc(60, 60, 20, 0, 2 * Math.PI, !0),
                          n.fill("evenodd");
                      })(e, n),
                      [Zn(e), t]);
                })(a, c));
          var u = ee(r),
            l = ee(o);
          return Promise.all([u, l]).then(function (n) {
            var [t, r] = n;
            return e({ a: Gn(c), b: t, c: r });
          });
        } catch (e) {
          n(e);
        }
      });
    },
    aas: function () {
      return new Promise(function (e, n) {
        try {
          var t = oe || window,
            r = Object.getOwnPropertyNames(t).filter(function (e) {
              return !/_|\d{3,}/.test(e);
            }),
            o = "Event";
          if (Z) {
            var i = r.indexOf(o);
            -1 != i &&
              ((r = r.slice(0, i).concat(r.slice(i + 1))),
              (r = [].concat(p(r), [o]))),
              ["PerformanceNavigationTiming", "Performance"].forEach(function (
                e
              ) {
                var n = r.indexOf(e);
                return -1 != n && (r = r.slice(0, n).concat(r.slice(n + 1))), r;
              });
          }
          var a = r.filter(function (e) {
              return /moz/i.test(e);
            }).length,
            c = r.filter(function (e) {
              return /webkit/i.test(e);
            }).length,
            u = r.filter(function (e) {
              return /apple/i.test(e);
            }).length,
            l = { keys: r, apple: u, moz: a, webkit: c },
            s = r.findIndex(function (e) {
              return "HTMLStyleElement" === e;
            });
          ee(l)
            .then(function (n) {
              e({ [Rn]: u, [Cn]: a, [An]: c, z: n, [kn]: s });
            })
            .catch(function (e) {
              return n(e);
            });
        } catch (e) {
          n(e);
        }
      });
    },
    aad: function () {
      var e = (oe && oe.document && oe.document.body ? oe : window).document,
        n = e.body;
      n.style.fontSize = "48px";
      var t = e.createElement("div");
      t.style.setProperty("visibility", "hidden", "important");
      var r,
        o = {},
        i = {},
        a = function (n) {
          var r = e.createElement("span"),
            { style: o } = r;
          return (
            (o.position = "absolute"),
            (o.top = "0"),
            (o.left = "0"),
            (o.fontFamily = n),
            (r.textContent = "mmMwWLliI0O&1"),
            t.appendChild(r),
            r
          );
        },
        c = $e.map(a),
        u =
          ((r = {}),
          en.forEach(function (e) {
            r[e] = $e.map(function (n) {
              return (function (e, n) {
                return a("'".concat(e, "',").concat(n));
              })(e, n);
            });
          }),
          r);
      return (
        n.appendChild(t),
        $e.forEach(function (e, n) {
          (o[e] = c[n].offsetWidth), (i[e] = c[n].offsetHeight);
        }),
        en.filter(function (e) {
          return (
            (n = u[e]),
            $e.some(function (e, t) {
              return n[t].offsetWidth !== o[e] || n[t].offsetHeight !== i[e];
            })
          );
          var n;
        })
      );
    },
    acf: function () {
      var e,
        n = oe,
        t = !1;
      if (D) {
        var r = new n.Error();
        r.name = " ";
        var o = {
          get: function () {
            return (t = !0), "";
          },
        };
        n.Object.defineProperty(r, "stack", o);
        try {
          throw r;
        } catch (r) {}
        return n.console.debug(r), t;
      }
      if (M) {
        try {
          e = n.document.createElement("div");
          var i = {
            get: function () {
              throw ((t = !0), new Error());
            },
          };
          n.Object.defineProperty(e, "id", i), n.console.debug(e);
        } catch (r) {}
        return t;
      }
      return null;
    },
  };
function gt(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n &&
      (r = r.filter(function (n) {
        return Object.getOwnPropertyDescriptor(e, n).enumerable;
      })),
      t.push.apply(t, r);
  }
  return t;
}
function bt(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2
      ? gt(Object(t), !0).forEach(function (n) {
          i(e, n, t[n]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : gt(Object(t)).forEach(function (n) {
          Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
        });
  }
  return e;
}
var wt = {
    bm: function () {
      return new Promise(function (e) {
        var n = (function (e) {
            try {
              return (
                (localStorage &&
                  localStorage.getItem &&
                  localStorage.getItem(e)) ||
                null
              );
            } catch (e) {
              return null;
            }
          })(r.PERSISTANCE_KEY),
          t = (function () {
            for (
              var e = "".concat(r.PERSISTANCE_KEY, "="),
                n = document.cookie.split(";"),
                t = null,
                o = 0;
              o < n.length;
              o += 1
            ) {
              var i = n[o].trim();
              if (0 === i.indexOf(e)) {
                t = i.slice(e.length);
                break;
              }
            }
            return t;
          })();
        Ae(r.PERSISTANCE_KEY, void 0)
          .then(function (r) {
            e({ b: n, a: t, c: r });
          })
          .catch(function () {
            e({ b: n, a: t, c: null });
          });
      });
    },
    acp: function () {
      return new Promise(function (e) {
        if (D) return e("");
        var n = navigator.storage;
        null == n && e("noStorage"),
          n.getDirectory || e("noGetDirectory"),
          n.getDirectory().then(
            function () {
              e("");
            },
            function (n) {
              e(n.message);
            }
          );
      });
    },
    adb: function () {
      var e, n;
      return D && Y
        ? navigator.webkitTemporaryStorage
          ? new Promise(function (e) {
              navigator.webkitTemporaryStorage.queryUsageAndQuota(function (
                n,
                t
              ) {
                return e(t);
              });
            })
          : null !== (e = navigator) &&
            void 0 !== e &&
            null !== (n = e.storage) &&
            void 0 !== n &&
            n.estimate
          ? new Promise(function (e) {
              navigator.storage.estimate().then(function (n) {
                var { quota: t } = n || {};
                return e(t);
              });
            })
          : null
        : null;
    },
  },
  St = {
    abv: function () {
      var e = {},
        n = x(window),
        t = [];
      for (var [r, { window: o = [], document: i = [] }] of (window.document &&
        (t = x(window.document)),
      Object.entries(Re))) {
        var a = Ce.apply(void 0, [n].concat(p(o))),
          c =
            i.length > 0 && t.length > 0 && Ce.apply(void 0, [t].concat(p(i)));
        e[Le[r] || r] = a || c;
      }
      return e;
    },
    v: function (e) {
      var n = null == e ? void 0 : e.gl;
      if ((n || (n = de()), !n)) return Promise.resolve(null);
      if (!fe(n)) return Promise.resolve(null);
      var t =
          (function (e) {
            var n = e.getSupportedExtensions(),
              t = e.getContextAttributes(),
              r = [],
              o = [],
              i = [],
              a = [],
              c = [];
            if (t)
              for (var u of Object.keys(t))
                r.push("".concat(u, "=").concat(t[u]));
            var l = Se(e);
            for (var s of l) {
              var d = e[s];
              o.push(
                ""
                  .concat(s, "=")
                  .concat(d)
                  .concat(ye.has(d) ? "=".concat(e.getParameter(d)) : "")
              );
            }
            if (n)
              for (var f of n) {
                var m = e.getExtension(f);
                if (m)
                  for (var v of Se(m)) {
                    var p = m[v];
                    i.push(
                      ""
                        .concat(v, "=")
                        .concat(p)
                        .concat(ge.has(p) ? "=".concat(e.getParameter(p)) : "")
                    );
                  }
                else a.push(f);
              }
            be.forEach(function (n) {
              we.forEach(function (t) {
                var r = (function (e, n, t) {
                  var r = e.getShaderPrecisionFormat(e[n], e[t]);
                  return r ? [r.rangeMin, r.rangeMax, r.precision] : [];
                })(e, n, t);
                c.push("".concat(n, ".").concat(t, "=").concat(r.join(",")));
              });
            }),
              i.sort(),
              o.sort();
            var h = ["32926", "32928"],
              y = (o || []).map(function (e) {
                var n = e.split("=", 3),
                  t = n[0],
                  r = n[1];
                return void 0 !== n[2] || h.includes(r)
                  ? "".concat(t, "(").concat(r, ")=null")
                  : "".concat(t, "=").concat(r);
              }),
              g = i.map(function (e) {
                var n = e.split("=", 3),
                  t = n[0],
                  r = n[1],
                  o = n[2];
                return void 0 !== o && "34047" !== r
                  ? "".concat(t, "(").concat(r, ")=").concat(o)
                  : "".concat(t, "=").concat(r);
              });
            return {
              availableAttr: r.join("&"),
              PARAMS: o.join("&"),
              SHADR_PRCSN: c.join("&"),
              EXTN: n ? ee(n.join(",")) : "",
              EXTN_PARAM: i.join(","),
              PRC_EXTN_PARAM: (g || []).join(","),
              PRC_PRARAMS: (y || []).join("&"),
              l: a,
            };
          })(n) || {},
        {
          availableAttr: r,
          PARAMS: o,
          SHADR_PRCSN: i,
          EXTN: c,
          EXTN_PARAM: u,
          PRC_EXTN_PARAM: l,
          PRC_PRARAMS: s,
        } = t,
        d = a(t, ve);
      return Promise.all([
        ee(r),
        ee(o),
        ee(i),
        ee(c),
        ee(u),
        ee(s),
        ee(l),
      ]).then(function (e) {
        var [n, t, r, o, i, a, c] = e;
        return Promise.resolve(
          he(he({}, d), {}, { g: n, h: t, i: r, j: o, k: i, n: c, m: a })
        );
      });
    },
    adf: function () {
      return new Promise(function (e) {
        var n,
          t,
          r = !1;
        "undefined" != typeof AbortController && (t = new AbortController());
        var o = setTimeout(function () {
          (r = !0), t && t.abort(), e(!1);
        }, 50);
        fetch(
          "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
          Ie(
            Ie({}, xe),
            {},
            { signal: null === (n = t) || void 0 === n ? void 0 : n.signal }
          )
        )
          .then(function (n) {
            r || clearTimeout(o), "basic" === n.type && e(!0), e(!1);
          })
          .catch(function (n) {
            if (!r)
              return (
                clearTimeout(o),
                "AbortError" === n.name
                  ? e(!1)
                  : n instanceof TypeError
                  ? e(!0)
                  : void e(!1)
              );
          });
      });
    },
  },
  Et = {
    ae: function () {
      if (M && !H) {
        try {
          window.openDatabase(null, null, null, null);
        } catch (e) {
          return !0;
        }
        try {
          return (
            window.localStorage.setItem("test", "1"),
            window.localStorage.removeItem("test"),
            !1
          );
        } catch (e) {
          return !0;
        }
      }
      return null;
    },
    adc: function () {
      return D && !Y
        ? new Promise(function (e) {
            var n = !1;
            try {
              var t = window.webkitRequestFileSystem;
              t &&
                t(
                  window.TEMPORARY,
                  1,
                  function () {
                    n = !1;
                  },
                  function () {
                    n = !0;
                  }
                ),
                e(n);
            } catch {
              e(n);
            }
          })
        : null;
    },
    ada: function () {
      if (!_) return null;
      try {
        return !window.indexedDB;
      } catch (e) {
        return !0;
      }
    },
    z: function () {
      if (!D) return !1;
      var e = function (e, n) {
        if (0 === n.length || n.length > e.length) return -1;
        for (var t = 0; t < e.length; t += 1) {
          for (var r = 0, o = 0; o < n.length; o += 1) {
            if (e[t + o] !== n[o]) {
              r = 0;
              break;
            }
            r += 1;
          }
          if (r === n.length) return t;
        }
        return -1;
      };
      try {
        if ("brave" in navigator || "Brave" in navigator) return !0;
        var n = document.createElement("canvas");
        (n.width = 4), (n.height = 4), (n.style.display = "inline");
        var t = n.toDataURL();
        if ("" === t) return !0;
        for (
          var r = atob(t.split(",")[1]),
            o = r.length,
            i = new Uint8Array(o),
            a = 0;
          a < o;
          a += 1
        )
          i[a] = r.charCodeAt(a);
        var c = e(i, [73, 68, 65, 84, 24]);
        if (-1 === c) return !1;
        var u = e(i, [73, 69, 78, 68]);
        return (
          -1 !== u &&
          1321 !==
            i.slice(c + 5, u).reduce(function (e, n) {
              return e + n;
            }, 0)
        );
      } catch (e) {
        return !1;
      }
    },
    ar: function () {
      var { platform: e } = navigator;
      return (
        "MacIntel" === e &&
          M &&
          !F &&
          (e = (function () {
            if ("iPad" === navigator.platform) return !0;
            var { screen: e } = window,
              n = e.width / e.height;
            return (
              R([
                "MediaSource" in window,
                !!Element.prototype.webkitRequestFullscreen,
                n > 0.65 && n < 1.53,
              ]) >= 2
            );
          })()
            ? "iPad"
            : "iPhone"),
        e
      );
    },
    t: function () {
      return L(O(navigator.hardwareConcurrency), null);
    },
    j: function () {
      return L(O(navigator.deviceMemory), null);
    },
    f: function () {
      var e = null;
      return (
        Pe.forEach(function (n) {
          null === e && P("color-gamut", n) && (e = n);
        }),
        e
      );
    },
    e: function () {
      var { screen: e } = window;
      return e && e.colorDepth ? e.colorDepth : null;
    },
    ah: function () {
      var e = window.performance;
      return e && e.memory ? e.memory.jsHeapSizeLimit : null;
    },
    s: function () {
      return G;
    },
    acq: function () {
      function e(e, n, t, r, o) {
        return "<mmultiscripts>\n      <mi>"
          .concat(e, "</mi><mi>")
          .concat(n, "</mi><mi>")
          .concat(t, "</mi>\n      <mprescripts></mprescripts><mi>")
          .concat(r, "</mi><mi>")
          .concat(o, "</mi>\n    </mmultiscripts>");
      }
      var n = "<mrow><munderover><mmultiscripts><mo>âˆ</mo>";
      [
        ["ð”ˆ", "Ï…", "Ï„", "Ï", "Ïƒ"],
        ["ð”‡", "Ï€", "Î¿", "Î½", "Î¾"],
        ["ð”„", "Î´", "Î³", "Î±", "Î²"],
        ["ð”…", "Î¸", "Î·", "Îµ", "Î¶"],
        ["ð”‰", "Ï‰", "Ïˆ", "Ï•", "Ï‡"],
        ["â„­", "Î¼", "Î»", "Î¹", "Îº"],
      ].forEach(function (t) {
        n += e.apply(void 0, p(t));
      }),
        (n += "</munderover></mrow>");
      var t = oe && oe.document && oe.document.body ? oe : window,
        r = t.document,
        o = r.createElement("math");
      (o.style.whiteSpace = "nowrap"), (o.innerHTML = n), r.body.append(o);
      var i = I(o, t);
      return r.body.removeChild(o), i;
    },
    act: je,
    aan: function () {
      var e;
      return window.AudioContext &&
        null !== (e = new AudioContext().baseLatency) &&
        void 0 !== e
        ? e
        : -1;
    },
    aaj: function () {
      return navigator.vendor || "";
    },
    aak: function () {
      var e = [];
      return (
        Oe.forEach(function (n) {
          var t = window[n];
          t && "object" == typeof t && e.push(n);
        }),
        e.sort()
      );
    },
    af: function () {
      return _;
    },
    ab: function () {
      return W;
    },
    y: function () {
      return (
        (e = "connection"),
        D
          ? R([
              !("SharedWorker" in T),
              N[e] && "ontypechange" in N[e],
              !("sinkId" in new Audio()),
            ]) >= 2
          : !!Z &&
            R([
              "onorientationchange" in T,
              "orientation" in T,
              /android/i.test(N.appVersion),
            ]) >= 2
      );
      var e;
    },
    ag: function () {
      return M;
    },
    add: function (e) {
      var n = null == e ? void 0 : e.gl;
      if (n) {
        n.clearColor(0, 0, 1, 1);
        var t = n.createProgram();
        if (t) {
          Ee(
            n,
            t,
            0,
            "attribute vec2 p;uniform float t;void main(){float s=sin(t);float c=cos(t);gl_Position=vec4(p*mat2(c,s,-s,c),1,1);}"
          ),
            Ee(n, t, 1, "void main(){gl_FragColor=vec4(1,0,0,1);}"),
            n.linkProgram(t),
            n.useProgram(t),
            n.enableVertexAttribArray(0);
          var r = n.getUniformLocation(t, "t"),
            o = n.createBuffer();
          n.bindBuffer(34962, o),
            n.bufferData(34962, new Float32Array([0, 1, -1, -1, 1, -1]), 35044),
            n.vertexAttribPointer(0, 2, 5126, !1, 0, 0),
            n.clear(16384),
            n.uniform1f(r, 3.65),
            n.drawArrays(4, 0, 3);
        }
        var i = n.canvas.toDataURL();
        return ee(i);
      }
      return null;
    },
    ade: function (e) {
      try {
        var n,
          t,
          r,
          o,
          i,
          a,
          c,
          { gl: u } = e || {};
        if (!u) return Promise.resolve(null);
        if (!fe(u)) return Promise.resolve(null);
        try {
          c = u.getExtension("WEBGL_debug_renderer_info");
        } catch (e) {}
        return Promise.resolve({
          a:
            (null === (n = u.getParameter(u.VERSION)) || void 0 === n
              ? void 0
              : n.toString()) || "",
          b:
            (null === (t = u.getParameter(u.VENDOR)) || void 0 === t
              ? void 0
              : t.toString()) || "",
          c: c
            ? null === (r = u.getParameter(c.UNMASKED_VENDOR_WEBGL)) ||
              void 0 === r
              ? void 0
              : r.toString()
            : "",
          d:
            (null === (o = u.getParameter(u.RENDERER)) || void 0 === o
              ? void 0
              : o.toString()) || "",
          e: c
            ? null === (i = u.getParameter(c.UNMASKED_RENDERER_WEBGL)) ||
              void 0 === i
              ? void 0
              : i.toString()
            : "",
          f:
            (null === (a = u.getParameter(u.SHADING_LANGUAGE_VERSION)) ||
            void 0 === a
              ? void 0
              : a.toString()) || "",
        });
      } catch (e) {
        throw new Error(e);
      }
    },
    aa: function () {
      return D;
    },
    ad: function () {
      return Z;
    },
    ac: function () {
      return V;
    },
    aq: function () {
      return (
        !!(
          navigator.webdriver ||
          (CSS.supports("border-end-end-radius: initial") &&
            void 0 === navigator.webdriver)
        ) ||
        !(
          !/HeadlessChrome/.test(navigator.userAgent) &&
          !/HeadlessChrome/.test(navigator.appVersion)
        )
      );
    },
    abi: function () {
      return "serviceWorker" in Navigator.prototype;
    },
    ay: function () {
      var { screen: e } = window || {},
        n = function (e) {
          return L(j(e), null);
        },
        t = [n(null == e ? void 0 : e.width), n(null == e ? void 0 : e.height)];
      return t.sort().reverse(), t;
    },
    adg: function () {
      var e = navigator;
      return (
        e.language || e.userLanguage || e.browserLanguage || e.systemLanguage
      );
    },
    ia: function () {
      var e = oe;
      if (null != e && e.screen) {
        var { screen: n } = e,
          t = function (e) {
            return L(j(e), null);
          },
          r = [
            t(null == n ? void 0 : n.width),
            t(null == n ? void 0 : n.height),
          ];
        return r.sort().reverse(), r;
      }
      return null;
    },
  },
  Pt = {
    stage1: (wt = bt(bt({}, wt), ht)),
    stage2: (St = bt(bt({}, St), yt)),
    stage3: (Et = bt(bt({}, Et), pt)),
  };
function Ot() {
  return (Ot = n(function* (e) {
    return (
      (t = [
        Object.values(Pt.stage1 || {}),
        Object.values(Pt.stage2 || {}),
        Object.values(Pt.stage3 || {}),
      ]),
      (r = e),
      (o = q(
        (function (e, n) {
          return U.apply(this, arguments);
        })(
          t,
          function (e) {
            return (function (e, n) {
              var t = q(
                new Promise(function (t) {
                  var r = e.name;
                  J(
                    e.bind(null, n),
                    function () {
                      for (
                        var e = arguments.length, n = new Array(e), r = 0;
                        r < e;
                        r++
                      )
                        n[r] = arguments[r];
                      var o = n[2];
                      if (!n[0])
                        return t(function () {
                          return { error: n[1], name: o };
                        });
                      var i = n[1];
                      if (
                        (function (e) {
                          return "function" != typeof e;
                        })(i)
                      )
                        return t(function () {
                          return { value: i, name: o };
                        });
                      t(function () {
                        return new Promise(function (e) {
                          J(
                            i,
                            function () {
                              var t = n[2];
                              if (
                                !(arguments.length <= 0 ? void 0 : arguments[0])
                              )
                                return e({
                                  error:
                                    arguments.length <= 1
                                      ? void 0
                                      : arguments[1],
                                  name: t,
                                });
                              e({
                                value:
                                  arguments.length <= 1 ? void 0 : arguments[1],
                                name: t,
                              });
                            },
                            o
                          );
                        });
                      });
                    },
                    r
                  );
                })
              );
              return function () {
                return t.then(function (e) {
                  return e();
                });
              };
            })(e, r);
          },
          30
        )
      )),
      (function () {
        var e = n(function* () {
          var e = yield o,
            n = [];
          for (var t of e) n = [].concat(p(n), p(t));
          for (
            var r = yield (function (e, n) {
                return K.apply(this, arguments);
              })(
                n,
                function (e) {
                  return q(e());
                },
                26
              ),
              i = yield Promise.all(r),
              a = {},
              c = {},
              u = 0;
            u < i.length;
            ++u
          ) {
            var l,
              s = i[u],
              d = s.name;
            (a[d] = s.error ? null : s.value),
              s.error &&
                (c[d] =
                  (null === (l = s.error) || void 0 === l
                    ? void 0
                    : l.message) || "errored");
          }
          return { components: a, error: c };
        });
        return function () {
          return e.apply(this, arguments);
        };
      })()
    );
    var t, r, o;
  })).apply(this, arguments);
}
var jt = {
  initialize: (function () {
    var e = n(function* (e) {
      var n,
        o,
        i,
        a,
        c = { gl: de() },
        u = (function (e) {
          var { INITIALIZATION_VALIDATIONS: n } = r,
            { apiKey: t, apiSecret: o, env: i, sessionId: a } = e || {},
            c = "",
            u = "";
          return (
            k(e) &&
              (c = ""
                .concat(n.PLEASE_PROVIDE_TEXT, " ")
                .concat(n.API_KEY, ",\n      ")
                .concat(n.API_SECRET, ", ")
                .concat(n.SESSIONID, " and ")
                .concat(n.ENVIRONMENT, " ")
                .concat(n.TO_INITIALIZE_TEXT)),
            k(e) ||
              (t && "string" == typeof t) ||
              (u = "" !== u ? "".concat(u, ", ").concat(n.API_KEY) : n.API_KEY),
            k(e) ||
              (o && "string" == typeof o) ||
              (u =
                "" !== u
                  ? "".concat(u, ", ").concat(n.API_SECRET)
                  : n.API_SECRET),
            k(e) ||
              (i &&
                "string" == typeof i &&
                ["STAGE", "PROD", "DEV"].includes(i)) ||
              (u =
                "" !== u
                  ? "".concat(u, ", ").concat(n.ENVIRONMENT)
                  : n.ENVIRONMENT),
            k(e) ||
              a ||
              (u =
                "" !== u
                  ? "".concat(u, ", ").concat(n.SESSIONID)
                  : n.SESSIONID),
            "" !== u &&
              (c = ""
                .concat(n.PLEASE_PROVIDE_TEXT, " ")
                .concat(u, " ")
                .concat(n.TO_INITIALIZE_TEXT)),
            c
          );
        })(e);
      return u
        ? Promise.reject(new Error(u))
        : ((n = e.apiKey),
          (o = e.apiSecret),
          (i = e.env),
          (a = e.sessionId),
          (t.apiKey = n),
          (t.apiSecret = o),
          (t.env = i),
          (t.sessionId = a),
          document.getElementById("response"),
          Promise.resolve({
            get: function (e) {
              return new Promise(function (n, t) {
                var o;
                try {
                  (function () {
                    var e =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : 20;
                    return (function (e) {
                      var n =
                          arguments.length > 1 && void 0 !== arguments[1]
                            ? arguments[1]
                            : 1 / 0,
                        { requestIdleCallback: t } = window;
                      return t
                        ? new Promise(function (e) {
                            return t.call(
                              window,
                              function () {
                                return e();
                              },
                              { timeout: n }
                            );
                          })
                        : z(Math.min(e, n));
                    })(e, 2 * e);
                  })()
                    .then(function () {
                      return (function (e) {
                        return Ot.apply(this, arguments);
                      })(c);
                    })
                    .then(function (e) {
                      return e();
                    })
                    .then(function (i) {
                      var { components: a, error: c } = i;
                      return (function (e, n, t, r) {
                        return E.apply(this, arguments);
                      })(null, a, c, e).then(
                        function (e) {
                          var { ex: t, tId: r } = e;
                          (o = r), n(t);
                        },
                        function (e) {
                          t(new Error(r.COULD_NOT_GATHER_INTELLIGENCE_ERROR));
                        }
                      );
                    })
                    .catch(function (e) {
                      t(new Error(r.COULD_NOT_GATHER_INTELLIGENCE_ERROR));
                    })
                    .finally(function () {
                      var e;
                      o &&
                        ((function (e, n) {
                          var t = "".concat(r.PERSISTANCE_KEY, "=").concat(n),
                            o = "expires=".concat(
                              new Date(Date.now() + 31536e6).toUTCString()
                            ),
                            i = "";
                          document.cookie = [
                            t,
                            "path=/",
                            o,
                            i,
                            "SameSite=Lax",
                          ].join("; ");
                        })(0, (e = o)),
                        (function (e, n) {
                          try {
                            localStorage &&
                              localStorage.setItem &&
                              localStorage.setItem(e, n);
                          } catch (e) {}
                        })(r.PERSISTANCE_KEY, e),
                        me(r.PERSISTANCE_KEY, e).then(function () {}));
                    });
                } catch (e) {
                  t(new Error(r.COULD_NOT_GATHER_INTELLIGENCE_ERROR));
                }
              });
            },
          }));
    });
    return function (n) {
      return e.apply(this, arguments);
    };
  })(),
};
export { jt as default };
